<template id="app">
    <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <!-- Alert message -->
      <div>
        <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{alert_message}}</v-alert>
      </div>
      <!-- Header-->
      <header-component :headerTitle="headerText ? headerText : 'Reverse Logistics'" />
      <v-snackbar
        v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :location="snackbar.position === 'top' ? 'top' : 'bottom'">
        <v-layout align-center pr-4>
          <v-icon class="pr-3 ml-2" dark large>{{ snackbar.icon }}</v-icon>
          <v-layout column>
            <div>{{ snackbar.text }}</div>
          </v-layout>
        </v-layout>
        <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-snackbar>
      <!-- Popup UI -->
        <!-- successfully -->
        <v-row justify="center">
        <v-dialog v-model="successfulPopup" persistent max-width="700px">
          <v-card class="v-card-100" style="background: #009818; border-radius: 4px;">
              <v-card-title>
                <v-icon color="#ffffff">mdi-checkbox-marked-circle</v-icon>
                <span class="successfulpopup pl-2">Trip Created Successfully</span><br>
                <v-spacer></v-spacer>
                <p class="successfulpopup mb-0" @click="successfulPopup = false">
                  Ok
                </p>
              </v-card-title>
          </v-card>
        </v-dialog>
      </v-row>

      <!-- Update Confirmation -->
      <v-row justify="center">
        <v-dialog v-model="confirmationGivenPopup" persistent max-width="834px">
          <v-card class="v-card-100">
            <v-card class="v-card-100">
              <v-card-title>
                <v-row class="ma-1">
                <span>Update Confirmation</span><br>
                <v-spacer></v-spacer>
                  <v-icon @click="confirmationGivenPopup = false">mdi-close</v-icon>
              </v-row>
              </v-card-title>
            </v-card>
            <v-card-text>
              <v-container>
               <v-row>
                <v-col v-if="active_tab == 'Logistics Requests' && selectedValue == 'ConfirmationGiven' || selectedValue == 'update_pickup_details' || selectedValue == 'update_drop_details'"  class="py-0">
                    <v-menu
                      v-model="dateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ props }">
                        <v-text-field
                          v-model="dateMenu_Confirmation"
                          :label="updateLabelName()"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          variant="outlined"
                          v-bind="props"
                          :disabled="disabled_date_time"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="logistics_partner_date" @input="dateMenu = false" :min="new Date(new Date().setDate(new Date().getDate() - buffer_days)).toISOString().substr(0, 10)"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col class="py-0" v-if="selectedValue == 'ConfirmationGiven' || selectedValue == 'update_pickup_details' || selectedValue == 'update_drop_details'">
                    <v-menu
                      v-model="timeMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ props }">
                        <v-text-field
                          v-model="executive_time"
                          :label="updateTimelabelName()"
                          prepend-inner-icon="mdi-clock"
                          readonly
                          variant="outlined"
                          v-bind="props"
                          :disabled="disabled_date_time"
                        ></v-text-field>
                      </template>
                      <v-time-picker ampm-in-title v-model="executive_time" @update:minute="timeMenu = false"></v-time-picker>
                    </v-menu>
                  </v-col>
                  <v-col class="py-0" v-if="selectedValue=='cancel' || selectedValue=='cancel1'">
                    <v-autocomplete prepend-inner-icon="mdi-magnify" v-model="cancellation_Reason" :items="cancellation_Reason_items" item-title="name" item-value="value"  label="Cancellation Reason" variant="outlined"/>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0" v-if="selectedValue == 'ConfirmationGiven'">
                  <v-autocomplete prepend-inner-icon="mdi-magnify" v-model="assistant_executive" :items="assistant_executive_items" item-title="name" item-value="value"  label="Remarks" variant="outlined" @update:modelValue="changeRemarks()"/>
                  </v-col>
                  <v-col class="py-0" v-if="selectedValue == 'update_pickup_details' || selectedValue == 'update_drop_details'">
                    <v-autocomplete prepend-inner-icon="mdi-magnify" v-model="select_doc" :items="select_doc_items" label="Select Doc" variant="outlined" @update:modelValue="changeRemarks()"/>
                    </v-col>
                  <v-col class="py-0" v-if="selectedValue == 'update_pickup_details' || selectedValue == 'update_drop_details'">
                    <v-text-field
                      v-model="dispatch_docu_number"
                      label="Enter Doc. Number"
                      variant="outlined"
                    ></v-text-field>
                    </v-col>                    
                  <v-col class="py-0" v-if="selectedValue == 'cancel' || selectedValue == 'cancel1'">
                    <v-text-field
                      prepend-inner-icon="mdi-magnify"
                      v-model="other_remarks"
                      label="Remarks"
                      :disabled="cancellation_Reason !== 'Others'"
                      variant="outlined"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                    <v-col class="py-0" v-if="selectedValue == 'update_pickup_details' || selectedValue == 'update_drop_details'">
                    <v-file-input 
                       v-model="doc_file" 
                       variant="outlined" 
                       prepend-icon='' 
                       label="Attach Document" 
                       prepend-inner-icon="mdi-paperclip" 
                       accept=".pdf, .png" 
                       @change="changeFile" 
                       :error="fileError" 
                       :error-messages="fileErrorMessage"/>
                    </v-col>
                  </v-row>
                  <v-row v-if="document_name">
                  <v-col cols="2" sm="6" md="6" class="p-0">
                    <v-chip class="mt-1 ml-4" closable @click:close="document_name = ''">
                      <span v-if="document_name && document_name.length > 20">{{document_name.slice(0, 20) }}...</span>
                      <span v-else>{{ document_name}}</span>
                    </v-chip>
                  </v-col>
              </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions center class="margin-10">
              <v-spacer></v-spacer>
              <v-btn style="font-size: 16px;" text color="primary" variant="outlined" class="cancel-color btn-cancel mr-2 mb-3 text-none" @click="confirmationGivenPopup = false">Cancel</v-btn>
              <v-btn style="font-size: 16px;" color="primary"  variant="flat" class="mb-3 text-none" :disabled="!disabledConfirmButton" @click="submitUpdateConfirmation">Confirm</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      
      <!-- Change Assignment -->
      <v-row justify="center">
        <v-dialog v-model="changeAssignmentPopup2" persistent max-width="834px">
          <v-card class="v-card-100">
            <v-card class="v-card-100">
              <v-card-title>
                <v-row class="ma-1">
                <span>Update Assignment</span><br>
                <v-spacer></v-spacer>
                  <v-icon @click="changeAssignmentPopup2 = false">mdi-close</v-icon>
              </v-row>
              </v-card-title>
            </v-card>
            <v-card-text>
              <v-container>
               <v-row>
                  <v-col v-if="active_tab == 'Logistics Requests'" class="py-0">
                    <v-autocomplete prepend-inner-icon="mdi-magnify" v-model="change_assignment" :items="change_assignment_item" item-title="full_name" item-value="id" label="Select the Logistics Partners"  variant="outlined" @change="updateLogisticsExecutive"/>
                  </v-col>
                </v-row>
                <v-row>
                <v-col v-if="active_tab == 'Logistics Requests'" class="py-0">
                 <v-text-field v-model="vehicle_number_aasign" variant="outlined" label="Vehicle Number (Optional)" />
                </v-col>
                <v-col v-if="active_tab == 'Logistics Requests'" class="py-0">
                 <v-text-field prepend-inner-icon="mdi-magnify" v-model="driver_mobile_number" variant="outlined" label="Driver Mobile Number (Optional)" :rules="mobileRules" @input="validateMobile"/>
                </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions center class="margin-10">
              <v-spacer></v-spacer>
              <v-btn style="font-size: 16px;" text color="primary" variant="outlined" class="cancel-color btn-cancel mr-2 mb-3 text-none" @click="changeAssignmentPopup2 = false">Cancel</v-btn>
              <v-btn style="font-size: 16px;" color="primary"  variant="flat" class="mb-3 text-none" :disabled="!change_assignment" @click="submitUpdateAssignment">Confirm</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

      <!-- Assign/ Change Assignment -->
      <v-row justify="center">
        <v-dialog v-model="changeAssignmentPopup" persistent max-width="834px">
          <v-card class="v-card-100">
            <v-card class="v-card-100">
              <v-card-title>
                <v-row class="ma-1">
                <span>Update Assignment</span><br>
                <v-spacer></v-spacer>
                <!-- <v-btn icon @click="changeAssignmentPopup = false"> -->
                  <v-icon @click="changeAssignmentPopup = false">mdi-close</v-icon>
                <!-- </v-btn> -->
              </v-row>
              </v-card-title>
            </v-card>
            <v-card-text>
              <v-container>
               <v-row>
                  <v-col v-if="active_tab == 'Logistics Requests'" class="py-0">
                    <v-autocomplete prepend-inner-icon="mdi-magnify" v-model="logistics_partner" :items="logistics_partner_items" item-title="full_name" item-value="id"  label="Logistic Partner"  variant="outlined" @change="updateLogisticsExecutive"/>
                  </v-col>
                  <v-col class="py-0">
                    <v-autocomplete prepend-inner-icon="mdi-magnify" v-model="executive" :items="executive_items" item-title="full_name" item-value="id"  label="Executive" variant="outlined" :disabled="!logistics_partner && active_tab == 'Logistics Requests'"/>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0">
                    <v-autocomplete prepend-inner-icon="mdi-magnify" v-model="assistant_executive" :items="executive_items" item-title="full_name" item-value="id" label="Assistant Executive" :disabled="!logistics_partner && active_tab == 'Logistics Requests'"  variant="outlined"> </v-autocomplete>
                  </v-col>
                  <v-col class="py-0">
                    <v-text-field prepend-inner-icon="mdi-magnify" v-model="vehicle_number" variant="outlined" label="Vehicle Number" :disabled="!logistics_partner && active_tab == 'Logistics Requests'" />
                    <!-- <v-autocomplete prepend-inner-icon="mdi-magnify" v-model="vehicle_number" :items="assistant_executive_items" item-title="full_name" item-value="id" label="Vehicle Number" :disabled="!logistics_partner && active_tab == 'Logistics Requests'" outlined> </v-autocomplete> -->
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions center class="margin-10">
              <v-spacer></v-spacer>
              <v-btn style="font-size: 16px;" text color="primary" variant="outlined" class="cancel-color btn-cancel mr-2 mb-3 text-none" @click="changeAssignmentPopup = false">Cancel</v-btn>
              <v-btn style="font-size: 16px;" color="primary"  variant="flat" class="mb-3 text-none" @click="submitUpdateAssignment"
                :disabled="number > 0|| (active_tab == 'Logistics Requests' && !logistics_partner) || (active_tab != 'Logistics Requests' && ( !assistant_executive || !vehicle_number))">Confirm</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <!-- update status -->
      <v-row justify="center">
        <v-dialog v-model="updateStatusPopup" persistent max-width="367px">
          <v-card class="v-card-100">
            <v-card class="v-card-100 mt-0">
              <v-card-title>
                <v-row class="ma-1">
                <span>Update Status</span><br>
                <v-spacer></v-spacer>
                <!-- <v-btn icon @click="updateStatusPopup = false"> -->
                  <v-icon @click="updateStatusPopup = false">mdi-close</v-icon>
                <!-- </v-btn> -->
              </v-row>
              </v-card-title>
            </v-card>
            <v-card-text>
              <v-container>
               <v-row class="py-0">
                  <v-col class="py-0">
                    <v-autocomplete v-model="update_status" :items="update_status_items"  label="Select the status" item-title="name" item-value="name"  variant="outlined" style="max-width: 730px !important;"  :item-disabled="disabled" />
                  </v-col>
                </v-row>
               <v-row v-if="update_status == 'Closed'  || update_status == 'Completed'" class="py-0">
                  <v-col class="py-0">
                    <v-file-input v-model="status_file" variant="outlined" prepend-icon='' label="Add Proof of Delivery" append-icon="mdi-paperclip"/>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions center class="margin-10 ">
              <v-spacer></v-spacer>
              <v-btn style="font-size: 16px; border: solid; border-width: 1px;" text color="primary" class="cancel-color btn-cancel mr-2 mb-3 text-none" @click="updateStatusPopup = false">Cancel</v-btn>
              <v-btn style="font-size: 16px;" color="primary" variant="flat" class="mb-3 text-none" @click="submitUpdateStatus"
              :disabled="number > 0 || (update_status == 'Closed' && !status_file) || (update_status == 'Completed' && !status_file) || !update_status">Submit</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
  
      <!-- Create Trip -->
      <v-row justify="center">
        <v-dialog v-model="createTripPopup" persistent fullscreen max-width="1000px">
          <v-card class="v-card-100 mt-0">
          <v-card class="v-card-100 custom-shadow">
            <v-card-title class="pa-0">              
                <v-row class="ma-1">
                  <span>Create Trip</span>
                  <v-spacer></v-spacer>
                  <!-- <v-btn icon @click="createTripPopup = false"> -->
                    <v-icon @click="createTripPopup = false">mdi-close</v-icon>
                  <!-- </v-btn> -->
                </v-row>
              
            </v-card-title>
            </v-card>
            <v-card-text>
              <!-- <v-row class="ml-2 mb-2"> -->
                <!-- <span style=" font-size: 14px;font-weight: 500;"><span style="color: #9C9C9C;">Trip ID:</span> <span style="color: black;">TR7689</span></span> -->
                <v-spacer />
                <!-- <span>Click & Drag to re-arrange the sequence</span>
              </v-row> -->
              <div>
              <v-layout column class="custom-width-table">
                <v-data-table 
                    class="elevation-1 overflow-auto" 
                    :dense="true" density="compact" 
                    :headers="tripHeaders" 
                    :items="createtrips_selected" 
                    disable-pagination 
                    fixed-header 
                    height="100%" 
                    return-object 
                    :hide-default-footer="true" 
                    :items-per-page="createtrips_selected.length"
                    >
                    <template v-slot:[`item.aggregation_id`]="{ item }">
                        <span>
                            {{ item.aggregation_id }}
                            <span @click="toggleExpand(item)" v-if="isDuplicate(item)">
                                <v-icon color="primary" v-if="!item.is_expanded">mdi-plus</v-icon>
                                <v-icon color="primary" v-else>mdi-minus</v-icon>
                            </span>
                        </span>
                    </template>
                    <template v-slot:[`item.city`]="{ item }">
                        <span>{{ item.city ? item.city : '-' }}</span>
                    </template>
                    <template v-slot:[`item.pincode`]="{ item }">
                        <span>{{ item.pincode ? item.pincode : '-' }}</span>
                    </template>
                    <template v-slot:[`item.location`]="{ item }">
                        <template v-if="item.location && item.location.length > 15">
                            <v-tooltip location="bottom">
                                <template v-slot:activator="{ props }">
                                    <span v-bind="props" v-on="on">
                                        {{ item.location.substring(0, 15) + '...' }}
                                    </span>
                                </template>
                                <span style="white-space: nowrap;">{{ item.location }}</span>
                            </v-tooltip>
                        </template>
                        <template v-else>
                            {{ item.location ? item.location : '-' }}
                        </template>
                    </template>
                    <template v-slot:[`item.sequence`]="{ item }">
                        <v-text-field density="compact" v-if="!item.is_crm_duplicate && !item.is_expanded" v-model="item.sequence" placeholder="Enter sequence" type="number" @keypress="validatePositiveNumber" />
                    </template>
                    <template #bottom></template>
                </v-data-table>
            </v-layout>
            </div>
              <!-- <v-container class="text-center">
                <div class="mb-2"><v-icon color="error" size="40">mdi-alert-circle-outline</v-icon></div>
                <p class="warningText">Please Add sequence</p>
              </v-container> -->
            </v-card-text>
            <v-card-actions center>
              <v-spacer></v-spacer>
              <v-btn style="font-size: 16px;" color="primary" variant="outlined" class="mb-3 text-none" @click="createTripPopup = false">Cancel</v-btn>
              <v-btn style="font-size: 16px;" variant="flat" color="primary" class="mb-3 text-none" @click="submitCreateTrip" :disabled="number>0 || checkAllSequence()">Submit</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
  
       <!-- Delete Trip -->
       <v-row justify="center">
        <v-dialog v-model="deleteTripPopup" persistent max-width="424px">
          <v-card class="v-card-100">
            <v-card-title>
              <v-row class="ma-1">
              <v-spacer></v-spacer>
              <!-- <v-btn icon @click="deleteTripPopup = false"> -->
                <v-icon @click="deleteTripPopup = false">mdi-close</v-icon>
              <!-- </v-btn> -->
            </v-row>
            </v-card-title>
            <v-card-text>
              <v-container class="text-center">
                <p class="warningText">Are you sure you want to delete ?</p>
              </v-container>
            </v-card-text>
            <v-card-actions center class="margin-10 ">
              <v-spacer></v-spacer>
              <v-btn style="font-size: 16px; border: solid; border-width: 1px;" text color="primary" class="cancel-color btn-cancel mr-2 mb-3 text-none" @click="deleteTripPopup = false">Cancel</v-btn>
              <v-btn style="font-size: 16px;" variant="flat" color="primary" class="mb-3 text-none" @click="deleteTrackTrip">Confirm</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

      <!--  Odometer image popup-->
       <v-row justify="center">
        <v-dialog v-model="odometerImagePopup" persistent max-width="424px">
          <v-card class="v-card-100">
          <v-card class="v-card-100 mt-0 custom-shadow">
            <v-card-title class="pa-0">
              <v-row class="ma-1">
              <span>{{odometer_label}}</span>
              <v-spacer></v-spacer>
                <v-icon @click="odometerImagePopup = false">mdi-close</v-icon>
            </v-row>
            </v-card-title>
            </v-card>
            <v-card-text>
                <img :src="odometer_image" alt="Image" class="image-fit"/>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
      
       <!-- filter data popup -->
      <v-row justify="center">
        <v-dialog content-class="filter-dispatch" v-model="filteWithSubPopup" persistent :max-width="filter_width">
          <v-card style="overflow: hidden;" class="px-3 py-2 filter_ui">
            <v-card-actions>
              <v-row class="mt-2">
              <v-col cols="12" sm="3" lg="3">
               <v-autocomplete prepend-inner-icon="mdi-magnify" clearable v-model="type_of_request" :items="type_of_request_items" multiple item-title="name" item-value="value" label="Type Of Request" variant="outlined" max-width="300px"> </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" lg="3">
                <v-autocomplete class="text-left" prepend-inner-icon="mdi-magnify" clearable v-model="logistics_partner" :items="logistics_partner_items" multiple item-title="full_name" item-value="full_name" label="Logistics Partner" variant="outlined" max-width="300px"> </v-autocomplete>
               <!-- <v-text-field v-model="logistics_partner" label="Logistics Partner" variant="outlined"> </v-text-field> -->
              </v-col>
               <v-col cols="12" sm="3" lg="3">
                <v-combobox v-model="status" :items="filtered_status_items" label="Status" variant="outlined" multiple clearable> </v-combobox>
              </v-col>
               <v-col cols="12" sm="3" lg="3">
                <v-menu
                  ref="menu3"
                  v-model="menu3"
                  :close-on-content-click="false"
                  v-model:return-value="bid_start_date"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ props }">
                    <v-text-field
                      variant="outlined"
                      v-model="formattedStartDate"
                      label="Creation Date"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      v-bind="props"
                    ></v-text-field>
                  </template>
                  <v-card class="m-0 overflow-hidden calendar-layout" width="315">
                    <v-date-picker :max="new Date().toISOString().substr(0, 10)" v-model="bid_start_date" hide-header color="primary" min-width="200" no-title
                      scrollable>
                    </v-date-picker>
                    <v-card-action class="d-flex justify-end pb-3">
                      <v-spacer></v-spacer>
                      <v-btn variant="text" class="text-none " color="primary" @click="cancelExpiryDate">Cancel</v-btn>
                      <v-btn variant="text" class="text-none " color="primary" @click="menu3 = false">Ok</v-btn>
                    </v-card-action>
                  </v-card>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3" lg="3">
                <v-combobox v-model="dealer" :items="dealer_items" label="Dealer" variant="outlined" multiple clearable item-title="name" item-value="code"> </v-combobox>
              </v-col>
               </v-row>           
             
            </v-card-actions>
            <v-card-actions class="margin-10">
              <v-spacer></v-spacer>
              <v-btn style="font-size: 14px; border: solid; border-width: 1px;" class="text-none" color="blue-darken-4" variant="outlined" @click="closeFilter">Cancel</v-btn>
              <v-btn style="font-size: 14px;" color="primary" class="text-none" variant="flat" @click="loadData(active_tab,'filter')">Apply Filter(s)</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <!-- reference popup -->
      <v-row justify="center">
        <v-dialog v-model="referenceDocPopup" persistent max-width="800px">
          <v-card class="v-card-100">
            <v-card class="v-card-100 pa-1">
              <v-card-title>
                <v-row ma-1>
                  <span>Reference Doc No: <span style="color:#79747E;font-weight: 400;">{{ $isWhirlpoolClient() && itemInformation.reference_document_number ? itemInformation.reference_document_number : itemInformation.referance_document_number ? itemInformation.referance_document_number : '-' }}</span>
                </span>
                <v-spacer></v-spacer>
                <!-- <v-btn icon @click="referenceDocPopup = false"> -->
                  <v-icon @click="referenceDocPopup = false">mdi-close</v-icon>
                <!-- </v-btn> -->
            </v-row>
              </v-card-title>
            </v-card>
            <v-card-text>
              <div style="font-weight: 500;padding:12px 0px;">{{ itemInformation.request_type }}</div>
              <v-row style="background: #EAF4FF;padding: 0px 12px;">
                <v-col class="d-flex flex-column">
                  <span>ORRD Type</span>
                  <span class="value_css">{{ referenceDocData.orrd_type ? referenceDocData.orrd_type : '-' }}</span>
                </v-col>
                <v-col class="d-flex flex-column">
                  <span>ORRD Number</span>
                  <span class="value_css">{{ referenceDocData.orrd_number ? referenceDocData.orrd_number : '-' }}</span>
                </v-col>
                <v-col class="d-flex flex-column">
                  <span>Item Count</span>
                  <span class="value_css">{{ referenceDocData.item_count ? referenceDocData.item_count : '-' }}</span>
                </v-col>
                <v-col class="d-flex flex-column">
                  <span>ORD Number</span>
                  <span class="value_css">{{ referenceDocData.orrd_number ? referenceDocData.orrd_number : '-' }}</span>
                </v-col>
              </v-row>
                  
              <div>
                <v-layout column class="mt-6">
                      <v-data-table 
                        density="compact" 
                        :dense="true"
                        :headers="itemsHeaders"
                        :items="itemsTableData"
                        style="max-height: 300px;height:auto !important;" 
                        disable-pagination
                        return-object 
                        :hide-default-footer="true"
                        class="elevation-1">
                        <template #bottom></template>
                      </v-data-table>
                </v-layout>
              </div>
  
              <div style="background: #EAF4FF;padding: 12px;color:#002F9E; font-size: 16px;font-weight: 400;margin-top: 16px;">
                <span>Pickup Details</span>
              </div>
  
              <v-row class="px-3">
                <v-col class="d-flex flex-column">
                  <span>Address</span>
                  <span class="value_css">{{ referenceDocData.pickup_details && referenceDocData.pickup_details.address ? referenceDocData.pickup_details.address : '-' }}</span>
                </v-col>
                <v-col class="d-flex flex-column">
                  <span>City</span>
                  <span class="value_css">{{ referenceDocData.pickup_details && referenceDocData.pickup_details.city ? referenceDocData.pickup_details.city : '-' }}</span>
                </v-col>
                <v-col class="d-flex flex-column">
                  <span>Pin Code</span>
                  <span class="value_css">{{ referenceDocData.pickup_details && referenceDocData.pickup_details.pin_code ? referenceDocData.pickup_details.pin_code : '-' }}</span>
                </v-col>
                <v-col class="d-flex flex-column">
                  <span>State</span>
                  <span class="value_css">{{ referenceDocData.pickup_details && referenceDocData.pickup_details.state ? referenceDocData.pickup_details.state : '-' }}</span>
                </v-col>
              </v-row>
              <v-row class="px-3">
                <v-col class="d-flex flex-column">
                  <span>POC Name</span>
                  <span class="value_css">{{ referenceDocData.pickup_details && referenceDocData.pickup_details.poc_name ? referenceDocData.pickup_details.poc_name : '-' }}</span>
                </v-col>
                <v-col class="d-flex flex-column">
                  <span>POC Contact No.</span>
                  <span class="value_css">{{ referenceDocData.pickup_details && referenceDocData.pickup_details.poc_contact_number ? referenceDocData.pickup_details.poc_contact_number : '-' }}</span>
                </v-col>
                <v-col class="d-flex flex-column">
                  <span>Vehicle Number</span>
                  <span class="value_css">{{ referenceDocData.pickup_details && referenceDocData.pickup_details.vehicle_number ? referenceDocData.pickup_details.vehicle_number : '-' }}</span>
                </v-col>
                <v-col class="d-flex flex-column">
                  <span>Vehicle Type</span>
                  <span class="value_css">{{ referenceDocData.pickup_details && referenceDocData.pickup_details.vehicle_type ? referenceDocData.pickup_details.vehicle_type : '-' }}</span>
                </v-col>
              </v-row>
              <v-row class="px-3">
                <v-col class="d-flex flex-column">
                  <span>Logistic Executive</span>
                  <span class="value_css">{{ referenceDocData.pickup_details && referenceDocData.pickup_details.logistic_executive ? referenceDocData.pickup_details.logistic_executive : '-' }}</span>
                </v-col>
                <v-col class="d-flex flex-column">
                  <span>Logistic Executive Contact No</span>
                  <span class="value_css">{{ referenceDocData && referenceDocData.logistic_executive_contact_number ? referenceDocData.logistic_executive_contact_number : '-' }}</span>
                </v-col>
                <v-col class="d-flex flex-column">
                  <span>Logistic Assistant</span>
                  <span class="value_css">{{ referenceDocData.pickup_details && referenceDocData.pickup_details.logistic_assistance ? referenceDocData.pickup_details.logistic_assistance : '-' }}</span>
                </v-col>
                <v-col class="d-flex flex-column">
                  <span>Logistic Assistant Contact No</span>
                  <span class="value_css">{{ referenceDocData && referenceDocData.logistic_assistant_executive_contact_number ? referenceDocData.logistic_assistant_executive_contact_number : '-' }}</span>
                </v-col>
              </v-row>
  
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
      
       <!-- Edit popup in Track Trips -->
      <v-row justify="center">
        <v-dialog v-model="editPopup" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
          <v-toolbar dark color="primary">
            <v-toolbar-title class="alert-link">Edit Request #{{ selected.length > 0 ? selected[0].trip_tag_id :''}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-card-actions>
                <v-btn class="bg-white text-none text-primary" small @click="saveAndUpdate" :disabled="number > 0 || checkAllSequenceEdit()">Save & Update</v-btn>
                <v-btn icon solo dark @click="editPopup = false"><v-icon color="white">mdi-close</v-icon></v-btn>
              </v-card-actions>
            </v-toolbar>
          <v-card class="v-card-100 m-0">
              <v-card-title class="action-style">
                  <v-row class="my-4 mx-3">
                    <v-row class="m-0 d-flex align-center">
                      <v-autocomplete
                        class="mr-4"
                        :items="field_item"
                        v-model="field_type"
                        item-value="value"
                        style="max-width: 152px; min-height:50px;"
                        item-title="name"
                        hide-details
                        color="primary"
                        label="Select Field"
                        variant="outlined"
                      ></v-autocomplete>
                      <v-text-field
                            color="primary"
                            prepend-inner-icon="mdi-magnify"
                            v-if="active_tab != 'Pick Up'"
                            v-model="edit_search"
                            label="Search"
                            hide-details
                            style="max-width: 300px; min-height:50px;"
                            variant="outlined"
                            :disabled="!field_type"
                            v-on:keyup.enter="editDialog('search')"
                      ></v-text-field>
                      <v-row class="m-0 d-flex align-center">
                        <v-spacer></v-spacer>
                        <v-btn class="mr-2 text-none" variant="flat" size="x-large" color="primary" @click="addMoreItems">Add More Activity</v-btn>
                        <v-btn class="mr-2 text-none" variant="flat" size="x-large" color="primary" :disabled="!canDeleteActivites" @click="changeAssignmentFunc">Change Assignment</v-btn>
                        <v-btn class="mr-2 text-none" variant="flat" size="x-large" color="primary" :disabled="!canDeleteActivites" @click="deleteEditTracker">Delete Activities</v-btn>
                      </v-row>
                    </v-row>
                </v-row>
                </v-card-title>
            <v-card-text class="px-0 py-1">
              <flex column class="edit_table">
                  <v-data-table hover
                    density="compact"
                    :dense="true"
                    :search="search"
                    v-model="selected_edit"
                    show-select
                    :headers="edit_headers"
                    :items="edit_table_data"
                    disable-pagination
                    fixed-header
                    height="100%"
                    :hide-default-footer="true"
                    :loading="loading"
                    loading-text="Loading Data... Please wait"
                    class="elevation-1 edit_table"
                    return-object 
                    :items-per-page="edit_table_data.length"
                  >
                  <template v-slot:[`item.aggregation_id`]="{ item }">
                    <span>
                      {{ item.aggregation_id }}
                      <span @click="toggleEditExpand(item)" v-if="isEditDuplicate(item)">
                        <v-icon color="primary" v-if="!item.is_expanded">mdi-plus</v-icon>
                        <v-icon color="primary" v-else>mdi-minus</v-icon>
                      </span>
                    </span>
                  </template>
                  <template #[`item.logistic_request_id`]="{ item }">
                    <a href="#" style="text-decoration: underline !important; color: #1976d2 !important; cursor: pointer !important;">{{ item.logistic_request_id }}</a>
                    </template>
                    <template #[`item.referance_document_number`]="{ item }">
                    <a href="#" style="text-decoration: underline !important; color: #1976d2 !important; cursor: pointer !important;">{{ item.referance_document_number }}</a>
                    </template>
                    <template v-slot:[`item.trip_sequence`]="{ item }">
                      <v-text-field  v-if="!item.is_crm_duplicate && !item.is_expanded" v-model="item.trip_sequence" placeholder="Enter sequence" type="number" @keypress="validatePositiveNumber"/>
                    </template>
                    <template #[`item.excepted_date_and_time`]="{ item }">
                      <span>{{
                        item.excepted_date_and_time ? item.excepted_date_and_time : "-"
                      }}</span>
                    </template>
                  <template #bottom></template>
                  </v-data-table>
                </flex>
              </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
      <!-- cAdd more data popup -->
      <v-row justify="center">
        <v-dialog v-model="addMorePopup" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
          <v-toolbar dark color="primary">
              <v-toolbar-title class="alert-link">Selected Item - {{ selected_add.length }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-card-actions>
                  <v-btn class="bg-white text-primary text-none" small @click="addEdit" :disabled="!canAddActivites">Add</v-btn>
                  <v-btn icon solo dark @click="addMorePopup = false">
                    <v-icon color="white">mdi-close</v-icon></v-btn>
                </v-card-actions>
              </v-toolbar>
          <v-card class="v-card-100 m-0">
              <v-card-title class="action-style">
                  <v-row class="my-4 mx-3">
                    <v-row class="m-0 d-flex align-center">
                      <v-text-field
                          color="primary"
                          prepend-inner-icon="mdi-magnify"
                          v-if="active_tab != 'Pick Up'"
                          v-model="change_search"
                          label="Search"
                          hide-details
                          style="max-width: 300px; min-height:50px;"
                          variant="outlined"
                          v-on:keyup.enter="addMoreItems('search')"
                      ></v-text-field>
                      <v-spacer></v-spacer>
                    </v-row>
                  </v-row>
              </v-card-title>
              <v-card-text class="px-0 py-1">
                <flex column class="add_table">
                    <v-data-table hover
                      density="compact"
                      :dense="true"
                      :search="search"
                      v-model="selected_add"
                      show-select
                      :headers="addmore_headers"
                      :items="addmore_table_data"
                      :loading="loading"
                      disable-pagination
                      :hide-default-footer="true"
                      return-object 
                      fixed-header
                      height="100%"
                      :items-per-page="pageSize"
                      loading-text="Loading Data... Please wait"
                      class="elevation-1 add_table"
                    >
                      <template #[`item.logistic_request_id`]="{ item }">
                        <a href="#" style="text-decoration: underline !important; color: #1976d2 !important; cursor: pointer !important;">{{ item.logistic_request_id }}</a>
                      </template>
                      <template #[`item.referance_document_number`]="{ item }">
                      <a href="#" style="text-decoration: underline !important; color: #1976d2 !important; cursor: pointer !important;">{{ item.referance_document_number }}</a>
                      </template>
                      <template #[`item.excepted_date_and_time`]="{ item }">
                        <span>{{
                          item.excepted_date_and_time ? item.excepted_date_and_time : "-"
                        }}</span>
                      </template>
                      <template #bottom></template>
                  </v-data-table>
                </flex>
              <div>
              <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected_add"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
            </div>
                </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>

     <!-- Main Content -->
       <v-card class="v-card-100">
        <v-tabs v-model="tab_index">
          <v-tab class="component-tab-heading" ripple :href="'#'" @click="loadData(tab, 'tab_clicked')"
            style="text-transform:none!important;text-decoration: none;" v-for="(tab, index) in tabs"
            :key="index">{{ tab }}</v-tab>
        </v-tabs>
      </v-card>
      <!-- Search, Action Buttons, Filter -->
      <v-card-title class="action-style pb-0">
        <!-- Search Fields -->
        <v-row class="ma-3 mb-0">
          <v-autocomplete class="text-left mr-4" v-model="select_field" item-title="name" item-value="id" :items="select_field_items" label="Select Field" variant="outlined" style="max-width: 158px;"> </v-autocomplete>
          <v-text-field prepend-inner-icon="mdi-magnify"   @input="search_tag = search_tag.trimStart().replace(/\s{2,}$/, ' ')" :disabled="!select_field" v-model="search_tag" label="Search" class="search_style" variant="outlined" style="max-width: 300px;" v-on:keyup.enter="search_tag = search_tag.trim(); loadData(active_tab)"></v-text-field>
          <DynamicHeader :headers="headers" :totalHeaderList="complete_headers" :updateHeaders="updateHeaders" :componentKey="active_tab" @saved_data_headers="handleSavedHeader"/>
          <v-spacer></v-spacer>
          <!-- Action Buttons -->
            <v-card-actions class="float-right mt-1" style="padding-top: 0px; padding-bottom: 0px; min-height: 56px;">
            <v-btn class="mb-8 text-none" variant="flat"  size="x-large" color="primary" v-if="active_tab == 'Logistics Requests'" @click="downloadFlatData">Download</v-btn>
              <DropdownButton
                 v-if="active_tab == 'Logistics Requests'"
                 :roles="roles"
                 :disabled="disbaledUpdateConfirm()"
                 buttonLabel="Update Confirmation"
                 :listItems="[
                  { value: 'ConfirmationGiven', label: 'Confirmation Given' },
                  { value: 'cancel', label: 'Cancel' }
                ]"
                :DropdownAction="DropdownAction"
                :disableCondition="disableCondition12"
              />
            <v-btn class="mb-7 text-none" variant="flat"  size="x-large" color="primary" :disabled="disbaledUpdateAssign()" v-if="active_tab == 'Logistics Requests'"
            @click="changeAssignmentFunc2">Update Assignment</v-btn>
             <DropdownButton
                  v-if="active_tab == 'Logistics Requests'"
                  :roles="roles"
                  :disabled="disbaledUpdateStatus()"
                  buttonLabel="Update Status"
                  :listItems="[
                    { value: 'update_pickup_details', label: 'Update Pickup Details' },
                    { value: 'update_drop_details', label: 'Update Drop Details' },
                    { value: 'cancel1', label: 'Cancel' }
                  ]"
                  :DropdownAction="DropdownAction"
                  :disableCondition="disableCondition11"
                />
            <!-- <v-btn class="mb-8 text-none" variant="flat" v-if="active_tab == 'Logistics Requests' && !roles.includes('logistics_manager')"  size="x-large" color="primary" :disabled="selected.length == 0" @click="updateStatusFunc">Update Status</v-btn> -->
            <v-btn class="mb-8 text-none" variant="flat"  size="x-large" color="primary" :disabled="!canCreateTrip" v-if="active_tab == 'Create Trips'" @click="createTripFunc">Create Trip</v-btn>
            <v-btn class="mb-8 text-none" variant="flat"  size="x-large" color="primary" :disabled="(selected.length == 0 || selected.some(item => item.status == 'Completed' || item.status == 'In Progress' || item.status == 'Pending Completion'))" v-if="active_tab == 'Track Trips'" @click="deleteTripFunc">Delete Trip</v-btn>
            <v-btn class="mb-8 text-none" variant="flat"  size="x-large" color="primary" :disabled="(selected.length != 1 || (selected[0].status == 'Completed'|| selected[0].status == 'In Progress' || selected[0].status == 'Pending Completion'))" v-if="active_tab == 'Track Trips'" @click="changeAssignmentFunc">Update Assignment</v-btn>
            <v-btn class="mb-8 text-none" variant="flat"  size="x-large" color="primary" :disabled="((selected.length != 1 || (selected[0].status == 'Completed')))" v-if="active_tab == 'Track Trips'" @click="updateStatusFunc">Update Status</v-btn>
            <v-btn class="mb-8 text-none" variant="flat"  size="x-large" color="primary" :disabled="(selected.length != 1 || !['To Be Assigned', 'Assigned'].includes(selected[0].status))" v-if="active_tab == 'Track Trips'" @click="editDialog">Edit</v-btn>
            
              <!-- <v-btn class="mb-8 text-none" x-large color="primary" :disabled="selected == 0"  @click="CreateRequest">Create Request</v-btn>-->
              <!-- <v-btn class="mb-8 text-none"  variant="flat" size="x-large" color="primary" :disabled="isButtonDisabled"  @click="EditRequest()">Edit Request</v-btn>  -->
            </v-card-actions>
            <!-- Filter -->       
        <v-expansion-panels class="custom-control_outlined m-0 pt-1" ref="filterPopupRef" readonly style="max-width: 110px; margin-bottom: 16px; height: 52px;">
          <v-expansion-panel variant="outlined" @click="filterListOfButtons" >
            <v-expansion-panel-title>Filter
            </v-expansion-panel-title>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
      </v-card-title>
  
      <!-- Data Table -->
      <v-layout column>
          <v-data-table 
            :dense="true"
             density="compact"
            :search="search"
            v-model="selected"
            show-select
            disable-pagination
            :hide-default-footer="true"
            :headers="headers"
            :items="table_data"
            :loading="loading"
            fixed-header
            height="100%"
            :items-per-page="pageSize"
            loading-text="Loading Data... Please wait"
            class="elevation-1"
            return-object>
              <template #headers="{ columns, toggleSort, isSorted, getSortIcon }">
                <tr>
                  <th>
                    <v-checkbox
                      :model-value="isAllSelectableSelected"
                      :indeterminate="isIndeterminate"
                      @click.stop="toggleSelectableItems"
                      hide-details
                      color="primary"
                      style="max-height: 40px !important;margin: -14px 0px 0px -6px;"
                    />
                  </th>
                  <th
                    v-for="column in columns.slice(1)"
                    :key="column.key"
                    @click="toggleSort(column)"
                    style="cursor: pointer;"
                    class="sortable-header"
                  >
                    <div class="d-flex align-center gap-1">
                      {{ column.title }}
                      <v-icon
                        v-if="isSorted(column)"
                        class="sort-icon"
                      >
                        {{ getSortIcon(column) }}
                      </v-icon>
                      <v-icon
                        v-else
                        class="sort-icon hover-icon"
                      >
                        mdi-arrow-up
                      </v-icon>
                    </div>
                  </th>
                </tr>
              </template>
            <template v-slot:[`#item.data-table-select`]="{ item }">
              <v-checkbox
                :model-value="selected.includes(item)"
                :disabled="isRowDisabled(item)"
                @update:modelValue="val => toggleSelect(item, val)"
                density="compact"
                hide-details
                class="ml-2"
              />
            </template>
            <template v-for="(header, index) in headers" :key="index" v-slot:[`item.${header.key}`]="{ item }">
              <template v-if="[ 'logistic_request_id', 'trip_tag_id', 'trip_id'].includes(header.key)">
                <span v-if="item[header.key]" style="color: #1976d2; cursor: pointer; text-decoration: underline;" @click="handleClick(header.key, item)">
                  <u>{{ item[header.key] }}</u>
                </span>
                <span v-else>-</span>
              </template>
              <span v-else-if="header.key === 'request_id'">
                <template v-if="active_tab === 'Update Logistics Details'">
                  <a style="color: #1976d2; cursor: pointer;" @click="DetailsPopup(item)">
                    <u>{{ item.logistics_request_id }}</u>
                  </a>
                </template>
                <template v-else-if="active_tab === 'Request Tracker'">
                  <a style="color: #1976d2; cursor: pointer;" @click="DetailsPopupRequestTrack(item)">
                    <u>{{ item.request_id }}</u>
                  </a>
                </template>
              </span>
              <span v-else-if="header.key === 'ageing_numeric'">
                <span>{{ item.ageing_numeric ? item.ageing_numeric + ' Day': '0 Day' }}</span>
              </span>
               <span v-else-if="header.key === 'fta_method'">
                <span>
                    {{
                      item.fta_method
                        ? item.fta_method.toLowerCase() === 'fta'
                          ? 'FTA'
                          : item.fta_method.toLowerCase() === 'non_fta'
                            ? 'Non FTA'
                            : item.fta_method
                        : '-'
                    }}
                  </span>
              </span>
              <span v-else-if="header.key === 'pickup_details'">
                <span>{{ item.pickup_details.city}}</span>
              </span>
              <span v-else-if="header.key === 'trip_sequence'">
                <v-text-field v-model="item.trip_sequence" placeholder="Enter Seq" regular type="number"/>
              </span>
              <span v-else-if="header.key === 'trip_id' && active_tab === 'Track Trips'">
                <a v-if="item.trip_id" @click="TrackTripDetailsPage(item)" style="color: #1976d2; cursor: pointer;text-decoration: underline">
                  <span>
                    <u>{{ item.trip_id }}</u>
                  </span>
                </a>            
              </span>
              <span v-else-if="header.key === 'created_date'">
                <span>{{ item.created_date ? item.created_date.slice(0,10) : '-' }}</span>
              </span>
              <span v-else-if="header.key === 'return_sub_request_id'">
                <span v-if="item.return_sub_request_id" @click="returnRequestDetailPopup(item, 'Sub Request ID')" style="color: #1976d2; cursor: pointer;text-decoration: underline;">
                    <u>{{ item.return_sub_request_id }}</u>
                  </span>
                </span>
                <span v-else-if="header.key === 'ticket_number'">
                  <span v-if="item.ticket_number" @click="returnRequestDetailPopup(item, 'Sub Request ID')" style="color: #1976d2; cursor: pointer;text-decoration: underline;">
                      <u>{{ item.ticket_number }}</u>
                 </span>
                </span>
              <span v-else-if="header.key === 'irrd_number' && (active_tab === 'Logistics Requests' || active_tab === 'Create Trips')">
                <span v-if="item.irrd_number" style="color: #1976d2; cursor: pointer;text-decoration: underline;" @click="TicketPopup(item)">{{ item.irrd_number }}
                </span>
                 <span v-else>-</span>
              </span>
              <span v-else-if="header.key === 'start_date'">
                <span>{{ formatDispatchDate(item.start_date) }}</span>
              </span>
              <span v-else-if="header.key === 'end_date'">
                <span>{{ formatDispatchDate(item.end_date) }}</span>
              </span>
              <span v-else-if="header.key === 'assignment_date'">
                <span>{{ formatDispatchDate(item.assignment_date) }}</span>
              </span>
              <span v-else-if="header.key === 'created_at'">
              <span>{{ formatDispatchDate(item.created_at) }}</span>
              </span>
              <span v-else-if="header.key === 'excepted_date_and_time'">
                <span>{{ formatDispatchDate(item.excepted_date_and_time) }}</span>
              </span>
              <span v-else-if="header.key === 'logistic_partner'">
                <span>{{ formatLogisticPartner(item.logistic_partner) }}</span>
              </span>
              <span v-else-if="header.key === 'suggested_pickup_time'">
                <span>
                  <v-tooltip location="bottom">
                    <template v-slot:activator="{ props }">
                      <span v-bind="props" :style="item.remarks ? 'text-decoration: underline;' : ''">
                        {{ item.suggested_pickup_time ? item.suggested_pickup_time : item.suggested_pickup_date ? item.suggested_pickup_date: "-"}}
                      </span>
                    </template>
                        <span>{{item.remarks}}</span>
                  </v-tooltip>
                </span>
              </span>              
              <span v-else-if="header.key === 'start_odometer_reading' && active_tab === 'Track Trips'">
                <span  v-if="item.start_odometer_reading">
                  <a @click="odometerOpenDialog(item.start_odometer_image, 'Start Odometer Reading')" style="color: #1976d2; cursor: pointer;text-decoration: underline">
                  <span>
                    <u>{{ item.start_odometer_reading }}</u>
                  </span>
                </a>
                </span>
                <span v-else>-</span>          
              </span>
              <span v-else-if="header.key === 'end_odometer_reading' && active_tab === 'Track Trips'">
                <span v-if="item.end_odometer_reading">
                <a @click="odometerOpenDialog(item.end_odometer_image, 'End Odometer Reading')" style="color: #1976d2; cursor: pointer;text-decoration: underline">
                  <span>
                    <u>{{ item.end_odometer_reading }}</u>
                  </span>
                </a> 
                </span>
                <span v-else>-</span>           
              </span>
              <span v-else-if="header.key === 'logistic_cost'">
                <v-text-field v-model="item.formatted_expected_liquidation" :disabled="item.status !== 'Pending Completion'"  @update:modelValue="formatExpectedLiquidation(item)" placeholder="Update">
                  <template #append>
                    <v-icon 
                      v-if="!item.isLoadingCost" 
                      :disabled="item.status !== 'Pending Completion' || !item.logistic_cost" 
                      color="primary" 
                      class="cursor-pointer" 
                      @click="updateTripLogiCost(item)"
                      >
                      mdi-arrow-right
                    </v-icon>
                    <v-progress-circular 
                      v-else 
                      indeterminate 
                      color="primary" 
                      size="20"
                    ></v-progress-circular>
                  </template>
                </v-text-field>
              </span>
              <span v-else-if="header.key === 'logistic_status' && active_tab === 'Logistics Requests'">
                    <span v-if="item.logistic_status === 'Failed'">
                      <a 
                      @click="FailedStatusClicked(item)" 
                      style="color: #1976d2; cursor: pointer; text-decoration: underline"
                      >
                        {{ item.logistic_status }}
                      </a>
                      <v-menu location="left bottom">
                        <template v-slot:activator="{ props }">
                          <v-icon class="me-2 ml-3" v-bind="props" :disabled="item.is_sync_to_control_tower">
                            mdi-dots-vertical
                          </v-icon>
                        </template>
                        <v-list>
                          <v-list-item v-for="(action, index) in editaction" :key="index">
                          <v-list-item-title style="color:#003C9E; cursor: pointer;" :style="action == 'Delete' ? 'color:red' : 'color:#003C9E'" @click="updateFailedAction(action,item)">{{ action }}</v-list-item-title>
                        </v-list-item>
                        </v-list>
                      </v-menu>
                    </span>

                    <span v-else-if="item.logistic_status === 'Cancelled'">
                      <a style="cursor: pointer; text-decoration: underline">
                      <span v-if="item.cancellation_reason">
                       <v-tooltip location="bottom">
                          <template v-slot:activator="{ props }">
                            <span v-bind="props">
                              {{ item.logistic_status }}
                            </span>
                          </template>
                          <span>{{item.cancellation_reason === 'Others' ? item.remarks : item.cancellation_reason}}</span>
                        </v-tooltip>
                        </span>
                        <span v-else>
                          {{ item.logistic_status }}
                        </span>                       
                      </a>
                      <v-menu location="left bottom">
                        <template v-slot:activator="{ props }">
                          <v-icon class="me-2 ml-3" v-bind="props" :disabled="item.is_sync_to_control_tower">
                            mdi-dots-vertical
                          </v-icon>
                        </template>
                        <v-list>
                          <v-list-item v-for="(action, index) in editaction" :key="index">
                          <v-list-item-title style="color:#003C9E; cursor: pointer;" :style="action == 'Delete' ? 'color:red' : 'color:#003C9E'" @click="updateFailedAction(action,item)">{{ action }}</v-list-item-title>
                        </v-list-item>
                        </v-list>
                      </v-menu>
                    </span>
                    <span v-else>
                      {{ item.logistic_status }}
                    </span>
                  </span>

              <span v-else-if="header.key !== 'images' && header.key !== 'logistic_cost' && item[header.key]">
                <GlobalTooltip :text="item[header.key]" />
              </span>
              <span v-else>-</span>
            </template>
          <template #bottom></template>
          </v-data-table>
      </v-layout>
            <div>
                <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
            </div>
    </v-card>
  </template>
  <script>
   import HeaderComponent from "../../../../commoncomponents/HeaderComponent.vue";
   import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
   import DynamicHeader from "../../../../commoncomponents/DynamicHeader.vue";
    export default {
      components : {
        HeaderComponent, DynamicHeader
      },
      data(){
          return {
          headerText: "FTA",
          alert : false,
          alert_type : "success",
          alert_message : '',
          search_tag: '',
          loading : false,
          selected:[],
          headers : [],
          table_data : [],
          search  : '',
          afterClickOkLoadData:'',
          changeAssignmentPopup: false,
          successfulPopup: false,
          executive_items : [],
          executive : '',
          updateStatusPopup: false,
          update_status_items : '',
          update_status : '',
          status_file: null,
          trackStatusList : [],
          createTripPopup: false,
          deleteTripPopup: false,
          filter_width : '950px',
          filteWithSubPopup: false,
          select_field_items: [],
          select_field:'',
          logistics_partner:null,
          type_of_request_items:[
            {
              "name":"Return",
              "value":"return"
            },
            {
            "name":"Replacement", 
            "value": "replacement"
            }
          ],
          logistics_partner_items:[],
          status_items:['To Be Assigned', 'Assigned','In Progress', 'Completed'],
          ageing_items:[],
          page: 1,
          totalPages: 1,
          totalCount: '',
          pageSize: defaultPageSize,
          pageSizes: defaultPageSizes,
          referenceDocPopup: false,
           referenceDocData: [],
           itemInformation:'',
           itemsHeaders: [
            { title : 'Article ID', key : 'sku_code'},
            { title : 'Article Description', key :'sku_description'},
            { title : 'Weight', key : 'weight'},
            { title : 'Volumetric Weight', key : 'volumetric_weight'},
          ],
          tripHeaders: [
            { title : 'Agregation ID', key : 'aggregation_id', width: '180px'},
            { title : 'LR ID', key : 'logistic_request_id',width: '150px'},
            { title : 'CRM Ticket No', key : 'crm_ticket_number',width: '180px'},
            { title : 'City', key :'city',width: '180px'},
            { title : 'Pin Code', key : 'pincode',width: '150px'},
            { title : 'Activity', key : 'activity_type',width: '150px'},
            { title : 'Activity Location', key : 'location',width: '150px'},
            { title : 'Sequence', key : 'sequence',width: '180px'},
          ],
          itemsTableData: [],
          assistant_executive_items:[],
          assistant_executive:'',
          vehicle_number_items:[],
          vehicle_number:'',
          organization_name: '',
          number:0,
          type_of_request:null,
          logistics_partner:null,
          ageing:null,
          status:null,
          tab_index:0,
          active_tab_condi:'',
          roles:[],
          bid_start_date:null,
          menu3: false,
          complete_executive_list : '',
          selected_edit:[],
          selected_add: [],
          edit_search: null,
          field_type:null,
          change_search: null,
          disabled: false,
          editPopup: false,
          addMorePopup: false,
          mobileRules: [
            v => !v || /^\d{10}$/.test(v) || 'Mobile number must be 10 digits',
          ],
          logistic_request_id : null,
          field_item: [
            { name: "LR ID", value: "logistic_request_id" },
            { name: "CRM Ticket No", value: "crm_ticket_number" },
            { name: "Ticket No", value: "sub_request_id" },
            { name: "Reference Doc No", value: "referance_document_number" },
          ],
          addmore_table_data:[],
          addmore_headers: [
            // { title : 'Client Name', key : 'client_name', minWidth :'250px'},
            { title: "LR ID", key: "logistic_request_id", align: "start", sortable: false,minWidth:"200px"},
            { title: "CRM Ticket No", key: "crm_ticket_number",minWidth:"250px" },
            { title: "Ticket No", key: "ticket_number",minWidth:"250px" },
            { title: "Reference Doc No", key: "referance_document_number",minWidth:"250px" },
            { title: "Request Type", key: "request_type",minWidth:"250px" },
            { title: "Activity Type", key: "activity_type",minWidth:"200px" },
            { title : 'Activity Location', key : 'location', minWidth :'200px'},
            { title: "City", key: "city",minWidth:"200px" },
            { title: "State", key: "state",minWidth:"200px" },
            { title: "Pin Code", key: "pincode",minWidth:"200px" },
            { title: "Expected date & Time", key: "excepted_date_and_time",minWidth:"200px" },
          ],
          edit_table_data:[],
          edit_headers: [
            { title: "LR ID", key: "logistic_request_id", align: "start", sortable: false,minWidth:"200px"},
            { title: "Agregation ID", key: "aggregation_id",minWidth:"250px" },
            { title: "CRM Ticket No", key: "crm_ticket_number",minWidth:"250px" },
            { title: "Ticket No", key: "sub_request_id",minWidth:"250px" },
            { title: "Reference Doc No", key: "referance_document_number",minWidth:"250px" },
            { title: "Request Type", key: "request_type",minWidth:"250px" },
            { title: "Activity Type", key: "activity_type",minWidth:"200px" },
            { title: "Sequence", key: "trip_sequence",minWidth:"180px" },
            { title: "City", key: "city",minWidth:"200px" },
            { title: "State", key: "state",minWidth:"200px" },
            { title: "Pin Code", key: "pincode",minWidth:"200px" },
            { title: "Expected date & Time", key: "excepted_date_and_time",minWidth:"200px" },
          ],
          snackbar: {
            color: null,
            icon: null,
            mode: null,
            position: "top",
            text: null,
            timeout: 7500,
            title: null,
            visible: false,
          },
          tabs:[
              "Logistics Requests",
              "Create Trips",
              "Track Trips"
          ],
          editaction: ["Reschedule","Delete"],
          sequence_table_data:[],
          logistic_partner_id:'',
          trip_id:'',
          is_filter:false,
          delete_activity_data:[],
          confirmationGivenPopup: false,
          cancellation_Reason: null,
          selectedValue: 'ConfirmationGiven',
          active_tab: 'Logistics Requests',
          dateMenu: false,
          timeMenu: false,
          logistics_partner_date: null,
          executive_time: null,
          cancellation_Reason_items: [],
          assistant_executive_items: [],
          upload_file: null,
          change_assignment:null,
          changeAssignmentPopup2: false,
          other_remarks:"",
          change_assignment_item: [],
          dispatch_docu_number: null,
          fta_logistics_has_taken: null,
          complete_edit_data : [],
          crm_ticket_dupl_details:{},
          crm_ticket_edit_dupl_details : {},
          createtrips_selected:[],
          odometer_label:'',
          odometerImagePopup:false,
          odometer_image:'',
          disabled_date_time:false,
          complete_headers: [],
          beforeHeaders: [],
          configurations: [],
          buffer_days: null,
          select_doc_items: [],
          select_doc: null,
          doc_file: null,
          fileErrorMessage:'',
          fileError: false,
          document_name: "",
          driver_mobile_number: null,
          vehicle_number_aasign: null,
          dealer_items: [],
          dealer:null,
          isSavedHeaderUsed: false,
          }
      },
      async created(){
        this.getPartnerExecutiveDetails();
        this.getDealerList()
        this.getTrackStatus()
        this.fta_logistics_has_taken = this.$store.state.fta_logistics
        this.headerText = this.$store.state.headerTextName
        this.organization_name = this.$store.state.organization_name;
        this.roles = this.$store.state.currentUser.roles
        this.configurations = this.$store.state.configurations;
        if(this.$store.state.username === 'eurekaforbes'){
          this.configurations = this.configurations.map(config =>{
            if(config.constant === 'CALL_CONTROL_TOWER'){
              config.is_enabled = false
            }
            return config
          })
        }
        const tab = this.$store.state.active_tab
        this.select_field = tab === "Track Trips" ? 'trip_id' : 'crm_ticket_no';
        if(tab == 'Track Trips'){
          this.tab_index = 2
          this.loadData('Track Trips');
        } else if(tab == 'Create Trips') {
          this.tab_index = 1
          this.loadData("Create Trips");
        } else {
          this.tab_index = 0
          this.loadData('Logistics Requests');          
        }

        if(this.fta_logistics_has_taken === false){
          this.tabs.splice(1,2)
        }
      },
  watch: {
      'table_data': {
        handler(newVal, oldVal) {
          newVal.forEach(item => {
            if (!isNaN(item.logistic_cost)) {
              item.formatted_expected_liquidation = this.formatCurrency(item.logistic_cost);
            }
          });
        },
        deep: true // Ensure deep watching for changes inside objects
      },
      'active_tab': {       
        handler(newTab) {
          this.loadHeadersFromStorage(newTab);
        },
        immediate: true,
      }
    },
  computed:{
        dateMenu_Confirmation() {
          if (!this.logistics_partner_date) return '';
          const date = new Date(this.logistics_partner_date);
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        },
        formattedStartDate() {
          if (this.bid_start_date) {
            const date = new Date(this.bid_start_date);
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
          }
          return '';
        },
        selectableItemIds() {
          return this.table_data.filter((item) => !item.is_sync_to_control_tower).map((item) => item.id)
          },
          isAllSelectableSelected() {
            const selected_ids = this.selected.map((item) => item.id);
            return (
              this.selectableItemIds.length > 0 &&
              this.selectableItemIds.every((id) => selected_ids.includes(id))
            )
          },
          isIndeterminate() {
            return (
              this.selected.length > 0 && !this.isAllSelectableSelected
            )
          },
        '$store.state.headerTextName': function(newTab) {
        this.headerText = newTab;
      },
      canCreateTrip() {
      if (this.selected.length === 0) return false;
        const groupedByCrm = this.groupBy(this.selected, "crm_ticket_number");
        const groupedBySerial = this.groupBy(this.selected, "serial_number");
        return this.selected.every((item) => {
          if (item.request_type === "Return") {
            const serialGroup = groupedBySerial[item.serial_number];
          return (
            serialGroup.length === 2 &&
            this.hasUniqueActivities(serialGroup)
          );
          } else if (item.request_type === "Replacement") {
            return (
              groupedByCrm[item.crm_ticket_number].length === 4 &&
              this.hasUniqueActivities(groupedByCrm[item.crm_ticket_number])
            );
          }
        return false;
      });
    },
    canAddActivites() {
      if (this.selected_add.length === 0) return false;
      const groupedByCrm = this.groupBy(this.selected_add, "crm_ticket_number");
      const groupedBySerial = this.groupBy(this.selected_add, "serial_number");
      return this.selected_add.every((item) => {
        if (item.request_type === "Return") {
          const serialGroup = groupedBySerial[item.serial_number];
            return (
              serialGroup.length === 2 &&
              this.hasUniqueActivities(serialGroup)
            );
        } else if (item.request_type === "Replacement") {
          return (
            groupedByCrm[item.crm_ticket_number].length === 4 &&
            this.hasUniqueActivities(groupedByCrm[item.crm_ticket_number])
          );
        }
        return false;
      });
    },
    canDeleteActivites() {
      if (this.selected_edit.length === 0) return false;
      const groupedByCrm = this.groupBy(this.selected_edit, "crm_ticket_number");
      return this.selected_edit.every((item) => {
        if (item.request_type === "Return") {
          return (
            groupedByCrm[item.crm_ticket_number].length === 2 &&
            this.hasUniqueActivities(groupedByCrm[item.crm_ticket_number])
          );
        } else if (item.request_type === "Replacement") {
          return (
            groupedByCrm[item.crm_ticket_number].length === 4 &&
            this.hasUniqueActivities(groupedByCrm[item.crm_ticket_number])
          );
        }
        return false;
        });
    },
    filtered_status_items(){
      this.status_items = this.status_items.map(item => item)
      if(this.active_tab == 'Track Trips'){
        this.status_items=['To Be Assigned', 'Assigned','In Progress', 'Pending Completion', 'Completed']
      }else if(this.active_tab == 'Create Trips'){
        this.status_items=['To Be Assigned', 'Assigned','In Progress', 'Completed']
      }else if(this.active_tab == 'Logistics Requests'){ 
        this.status_items=['To Be Assigned', 'Assigned','In Transit', 'Completed','Failed','To Be Confirmed','Cancelled']
      }
      return this.status_items
    },
    disabledConfirmButton(){
          if(this.selectedValue === 'ConfirmationGiven' && this.disabled_date_time === true){
            return (this.assistant_executive);
          }else if(this.selectedValue === 'ConfirmationGiven' && this.disabled_date_time === false){
            return (this.logistics_partner_date)
          }else if(this.selectedValue === 'cancel'){
            if(this.cancellation_Reason !== 'Others'){
              return (this.cancellation_Reason)
            }else{
              return (this.cancellation_Reason && this.other_remarks)
            }
          }else if(this.selectedValue === 'update_pickup_details' || this.selectedValue === 'update_drop_details'){
            return (this.logistics_partner_date);
          }else if(this.selectedValue === 'cancel1'){
            if(this.cancellation_Reason !== 'Others'){
              return (this.cancellation_Reason)
            }else{
              return (this.cancellation_Reason && this.other_remarks)
            }
          }
        }
  },
  methods: {
        validateMobile() {
          if (!this.driver_mobile_number) {
            this.driver_mobile_number = ''
            return
          }
          const digits = this.driver_mobile_number.replace(/\D/g, '')
          this.driver_mobile_number = digits.slice(0, 10)
        },
        isConfigEnabled(constantName) {
          const config = this.$store.state.configurations.filter(item => item.constant === constantName);
          return config.length ? config[0].is_enabled : false;
        },
        toggleSelectableItems() {
          if (this.isAllSelectableSelected) {
            this.selected = []
          } else {
            this.selected = this.table_data.filter(
              (item) => this.selectableItemIds.includes(item.id)
            )
          }
        },
        getStorageKey(tab) {
           return `dynamic_headers_${tab}`;
          },
        loadHeadersFromStorage(tab) {
            const saved = localStorage.getItem(this.getStorageKey(tab));
            if (saved) {
              this.headers = JSON.parse(saved);
            } else {
              this.headers = this.complete_headers;
            }
          },
        updateHeaders(headers){
          this.beforeHeaders = headers.map(header => header)
          this.headers = headers;
        },
        handleSavedHeader(savedData) {
        this.isSavedHeaderUsed = savedData;
      },
        isDuplicate(item) {
        return !item.is_crm_duplicate && this.crm_ticket_dupl_details[item.aggregation_id] && this.crm_ticket_dupl_details[item.aggregation_id].length;
      },
      isEditDuplicate(item){
        return !item.is_crm_duplicate && this.crm_ticket_edit_dupl_details[item.aggregation_id] && this.crm_ticket_edit_dupl_details[item.aggregation_id].length;
      },
      toggleEditExpand(data) {
        const index = this.edit_table_data.findIndex(item => item.aggregation_id === data.aggregation_id);
        if (index > -1) {
          data.is_expanded = !data.is_expanded;
          if (data.is_expanded) {
            this.edit_table_data.splice(index + 1, 0, ...this.crm_ticket_edit_dupl_details[data.aggregation_id]);
          } else {
            this.edit_table_data.splice(index + 1, this.crm_ticket_edit_dupl_details[data.aggregation_id].length);
          }
        }
      },
      toggleExpand(data) {
        const index = this.createtrips_selected.findIndex(item => item.aggregation_id === data.aggregation_id);
        if (index > -1) {
          data.is_expanded = !data.is_expanded;
          if (data.is_expanded) {
            this.createtrips_selected.splice(index + 1, 0, ...this.crm_ticket_dupl_details[data.aggregation_id]);
          } else {
            this.createtrips_selected.splice(index + 1, this.crm_ticket_dupl_details[data.aggregation_id].length);
          }
        }
      },
        validatePositiveNumber(event) {
          const charCode = event.charCode;
          if (charCode < 48 || charCode > 57) {
            event.preventDefault();
          }
        },
        checkAllSequence() {
          const sequences = this.createtrips_selected.map(item => String(item.sequence));
          // Check if any sequence is empty or there are duplicates
          const hasEmptySequence = sequences.some(seq => !seq || seq.trim() === '');
          const hasDuplicates = new Set(sequences).size !== sequences.length;
          return hasEmptySequence || hasDuplicates;
        },
        checkAllSequenceEdit() {
          const sequences = this.edit_table_data.filter(item => this.isEditDuplicate(item)).map(item => String(item.trip_sequence));
          const hasEmptySequence = sequences.some(seq => !seq || seq.trim() === '');
          const hasDuplicates = new Set(sequences).size !== sequences.length;
          return hasEmptySequence || hasDuplicates;
        },
          showAlert(alert_type, alert_message) {
          this.alert = true;
          this.alert_type = alert_type;
          this.alert_message = alert_message;
          this.scrollToTop();
          this.alertTimeOut();
        },
        groupBy(array, key) {
        return array.reduce((result, item) => {
          (result[item[key]] = result[item[key]] || []).push(item);
          return result;
        }, {});
      },
        hasUniqueActivities(items) {
          const activities = items.map((item) => item.activity_type);
          return new Set(activities).size === items.length;
        },
        alertTimeOut() {
          setTimeout(() => {
              this.alert = false;
          }, 3000);
        },
        scrollToTop() {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        },
        loadData(tab,tab_clicked){
          if(tab_clicked){
            this.search_tag = '';
            this.selected_field = '';
            this.select_field = tab === "Track Trips" ? 'trip_id' : 'crm_ticket_no';
          }
           
          if(tab_clicked === 'filter'){
           this.is_filter = true
          }else{
            this.is_filter = false;
            this.resetFilters();
          }
          
          this.active_tab = tab;
          this.table_data = [];
          this.page = 1;
          this.totalPages = 1;
          this.selected = [];
          this.$store.commit('setActiveTab',{
            'active_tab' : tab
          })
          if(tab === "Logistics Requests" && this.isSavedHeaderUsed === false){
            this.headers = [
              { title : 'Created On', key : 'created_date', minWidth :'200px'},
              { title : this.$isWhirlpoolClient() ? 'Ticket No':'Sub Request ID', key : 'return_sub_request_id', minWidth :'250px'},
              { title : 'CRM Ticket No', key : 'client_crm_ticket_no', minWidth :'250px'},
              { title: "Box ID", key: "box_id",minWidth:"250px" },
              { title: "Weight", key: "weight",minWidth:"250px" },
              { title: "Dimension", key: "dimension",minWidth:"250px" },
              { title : 'Return Item Serial No', key : 'serial_number', minWidth :'250px'},
              { title : 'Trip ID', key: 'trip_id'},
              { title : 'Reference Doc No', key : 'irrd_number', minWidth :'250px'},
              { title : 'Request type ', key : 'request_type', minWidth :'200px'},
              { title : 'Dealer', key : 'dealer_name_code', minWidth :'200px'},
              { title : 'Pick up City', key : 'city', minWidth :'200px'},
              { title : 'Suggested Pick up date & time', key : 'suggested_pickup_time', minWidth :'200px'},
              { title : 'Logistics Partner', key : 'logistic_partner'},
              { title : 'Method', key : 'fta_method', minWidth :'200px'},
              { title : 'Ageing(Days)', key : 'ageing_numeric', sortable: true},
              { title : 'Pickup Date', key : 'pickup_date_new', sortable: true},
              { title : 'Drop Date', key : 'drop_date_new', sortable: true},
              { title : 'Article ID', key : 'article_id', minWidth :'250px'},
              { title : 'Article Description', key : 'article_description', minWidth :'250px'},
              { title : 'Status', key: 'logistic_status', minWidth :'200px'},  
            ];
           if(this.organization_name === 'Voltas'){
              this.headers = this.headers.filter(header => !['client_crm_ticket_no','trip_id'].includes(header.key));
            }
          this.select_field_items = [
              {
                "name":"CRM Ticket No",
                "id": "crm_ticket_no"
              },
              {
                "name":"Ticket No",
                "id": "ticket_no"
              },
              {
                "name":"Reference Doc No",
                "id": "irrd_number"
              },
              {
                "name":"Trip ID",
                "id": "trip_id"
              },
              {
                "name":"Box ID",
                "id": "box_id"
              }
            ];            
          } else if(tab === "Create Trips" && this.isSavedHeaderUsed == false){
            this.headers = [
              { title : 'Logistic FTA Request ID', key : 'logistic_request_id', minWidth :'250px'},
              { title : 'CRM Ticket No', key : 'crm_ticket_number'},
              { title : 'Ticket No', key : 'ticket_number', minWidth :'200px'},
              { title : 'Reference Doc No', key : 'irrd_number', minWidth :'300px'},
              { title : 'Request Type', key : 'request_type', minWidth :'200px'},
              { title : 'Activity Type', key : 'activity_type', minWidth :'200px'},
              { title : 'Activity Location', key : 'location', minWidth :'200px'},
              { title : 'Method', key : 'fta_method', minWidth :'200px'},
              { title : 'City', key : 'city', minWidth :'200px'},
              { title : 'State', key : 'state', minWidth :'200px'},
              { title : 'Pin Code', key : 'pincode', minWidth :'200px'},
              { title : 'Expected Date & Time', key : 'excepted_date_and_time', minWidth :'300px'}
            ];
            this.select_field_items = [
              {
                "name":"CRM Ticket No",
                "id": "crm_ticket_no"
              },
              {
                "name":"Ticket No",
                "id": "ticket_no"
              },
              {
                 "name":"Reference Doc No",
                 "id": "irrd_number"
               },
             ];
            
          } else if(tab === "Track Trips" && this.isSavedHeaderUsed == false){
            this.headers = [
              { title : 'Trip Created Date', key : 'created_at', minWidth :'200px'},
              { title : 'Trip ID', key : 'trip_tag_id', minWidth :'200px'},
              { title : 'Logistics Partner', key : 'logistic_partner', minWidth :'200px'},
              { title : 'Logistics Exe', key : 'logistic_executive', minWidth :'200px'},
              { title : 'Assignment Date', key : 'assignment_date', minWidth :'200px'},
              { title : 'Ageing', key : 'ageing_numeric', minWidth :'200px'},
              { title : 'Trip Progress', key : 'trip_activity_status', minWidth :'200px'},
              { title : 'Start Date & Time', key : 'start_date', minWidth :'250px'},
              { title : 'End Date & Time', key : 'end_date', minWidth :'250px'},
              { title : 'Start Odometer Reading (Km)', key : 'start_odometer_reading', minWidth :'250px'},
              { title : 'End Odometer Reading (Km)', key : 'end_odometer_reading'},
              { title : 'Vehicle Number', key : 'vehicle_number', minWidth :'250px'},
              { title : 'Distance (Km)', key : 'trip_distance', minWidth :'250px'},
              { title : 'Logistic Cost (₹)', key : 'logistic_cost', minWidth :'250px'},
              { title : 'Status', key : 'status', minWidth :'200px'},
            ];
            this.select_field_items = [
              {
                "name":"Trip ID",
                "id": "trip_id"
              },
              {
                "name":"CRM Ticket No",
                "id": "crm_ticket_no"
              },
              {
                "name":"Logistics Partner",
                "id": "logistic_partner"
              },
              {
                "name":"Logistics Executive",
                "id": "logistic_executive"
              },
              {
                "name":"Reference Doc No",
                "id": "irrd_number"
              } 
            ];
          }
          if(tab === "Logistics Requests")
           this.fetchUpdateLogisticsDetail();
          else if(tab === "Create Trips")
           this.fetchCreateTripsDetail();
          else if(tab === "Track Trips")
           this.fetchTrackTripData();

          if(!this.isSavedHeaderUsed){
            if(this.is_filter === false){
            this.complete_headers = this.headers.map(item => item)
            this.headers = this.headers.map(item => item)
            }else {
              this.complete_headers = this.headers.map(item => item)            
              this.headers = this.beforeHeaders.length > 0 ? this.beforeHeaders : this.headers.map(item => item)
            }
          }
          
        },
        getTrackStatus(){
        this.$httpSecured
          .get("/api/v1/warehouse/return_initiation/logistic_request_trips/get_status_list")
          .then(response => {
              this.status_items = response.data.status
            }
          )
          .catch(error => {
            this.$toast.error(error.response.data.message)
          });
        },
        handleClick(key, item) {
          switch (key) {
            case 'reference_document_number':
              this.fetchreferenceFields(item);
              break;
            case 'return_sub_request_id':
              this.TicketPopup(item);
              break;
            case 'logistic_request_id':
              this.TicketPopup(item);
              break;
            case 'trip_tag_id':
              this.TicketPopup(item);
              break;
             case 'trip_id':
              this.TicketPopupLR(item);
              break;
            default:
              console.warn('Unhandled key:', key);
          }
        },
        cancelExpiryDate(){
          this.bid_start_date = null
          this.menu3 = false
        },
        getPartnerExecutiveDetails(){
        this.$httpSecured
          .get("/api/v1/warehouse/return_initiation/logistic_request/get_partner_executive_values")
          .then(response => {
              this.logistics_partner_items = response.data.logistic_partners
              this.change_assignment_item = response.data.logistic_partners
              this.executive_items = response.data.logistic_executive
              this.assistant_executive_items = response.data.logistic_assitance_executive
              this.complete_executive_list = response.data.logistic_partners
            }
          )
          .catch(error => {
            this.$toast.error(error.response.data.message)
          });
        },
        getDealerList(){
        this.$httpSecured
          .get("/api/v1/warehouse/return_initiation/logistic_request/vendor_list")
          .then(response => {
            const raw_data = response.data.dealer_codes || [];
              this.dealer_items = raw_data.map(([name, code]) =>{
                return {
                  name: `${name} (${code})`,
                  code
                }
              });
            }
          )
          .catch(error => {
            this.$toast.error(error.response.data.message)
          });
        },
        submitUpdateStatus(){
          this.number++
          const formData = new FormData()
          if(this.active_tab == 'Logistics Requests'){
            formData.append('return_item_ids',this.selected.map(item=>item.id))
          }else{
            formData.append('trip_ids',this.selected.map(item=>item.id))
          }
          
          formData.append('assign_status',this.update_status)
          if(this.update_status == 'Closed' || this.update_status == 'Completed')
          formData.append('file',this.status_file)
  
          const api = this.active_tab == 'Logistics Requests' ? "/api/v1/warehouse/return_initiation/logistic_request/update_status" : "/api/v1/warehouse/return_initiation/logistic_request_trips/update_status"
          this.$httpSecured
          .post(api,formData,{ headers: { 'Content-Type': 'multipart/form-data' }} )
          .then(response => {
              this.$toast.success(response.data.message)
              this.updateStatusPopup = false
              this.loadData(this.active_tab)
            }
          )
          .catch(error => {
            this.number = 0
            this.$toast.error(error.response.data.error)
          });
        },

        submitUpdateAssignment(){          
          this.number++
          if(this.active_tab == 'Logistics Requests'){
            let params = {}
            if(this.active_tab == 'Logistics Requests' && this.changeAssignmentPopup2 === true){
               params = {
              "return_item_ids": this.selected.map(item=> item.id),
              "logistic_partner_id": this.change_assignment,
              "vehicle_number": this.vehicle_number_aasign,
              "driver_number": this.driver_mobile_number              
            }
            }else{
              params = {
              "return_item_ids": this.selected.map(item=> item.id),
              "logistic_partner_id": this.logistics_partner,
              "logistic_executive_id": this.assistant_executive,
              "assistance_executive_id": this.executive,
              "vehicle_number": this.vehicle_number
            }
            }
            
            this.$httpSecured
            .post("/api/v1/warehouse/return_initiation/logistic_request/update_assignment", params )
            .then(response => {
                this.$toast.success(response.data.message)
                this.changeAssignmentPopup = false
                this.changeAssignmentPopup2 = false;
                this.logistics_partner = null
                this.assistant_executive = null
                this.executive = null
                this.vehicle_number = ""
                this.loadData(this.active_tab)
              }
            )
            .catch(error => {
              this.number = 0
              this.$toast.error(error.response.data.error)
            });
          } else {
            if(this.editPopup === true){
              this.changeAssignmentPopup = false;
              this.number = 0;
              return;
            }
            const params = {
              "trip_ids": this.selected.map(item=> item.id),
              "logistic_executive_id": this.assistant_executive,
              "assistance_executive_id": this.executive,
              "vehicle_number": this.vehicle_number
            }
            this.$httpSecured
            .post("/api/v1/warehouse/return_initiation/logistic_request_trips/update_assignment", params )
            .then(response => {
                this.$toast.success(response.data.message)
                this.changeAssignmentPopup = false
                this.loadData(this.active_tab)
              }
            )
            .catch(error => {
              this.number = 0
              this.$toast.error(error.response.data.error)
            });
          }
        },
        deleteTrackTrip(){
          this.number++;
          this.$httpSecured
          .post("/api/v1/warehouse/return_initiation/logistic_request_trips/delete_trips", { "trip_ids": this.selected.map(item=>item.id)} )
          .then(response => {
              this.$toast.success(response.data.message)
              this.deleteTripPopup = false
              this.loadData(this.active_tab)
            }
          )
          .catch(error => {
            this.number = 0
            this.$toast.error(error.response.data.message)
          });
        },
        fetchUpdateLogisticsDetail(){
          const params = {
            page: this.page,
            per_page: this.pageSize,
            request_type:this.type_of_request ? this.type_of_request : null ,            
            dealer_code: this.dealer ? this.dealer.map(item => item.code) : null,
            logistic_partner: this.logistics_partner || null,
            status: this.status || null,
            created_date: this.bid_start_date 
              ? String(this.bid_start_date).split('-').reverse().join('-') 
              : null,
          };
          if(this.search_tag){
            params[this.select_field] = this.search_tag
          }
          this.loading = true;
          this.$httpSecured
            .post("/api/v1/warehouse/return_initiation/logistic_request", params )
            .then(response => {
              if (response.data) {
                this.table_data = response.data.return_items.map( item => ({
                  ...item,
                  ageing_numeric: parseInt(item.ageing.split(' ')[0]),
                  dealer_name_code: `${item.dealer_name} (${item.dealer_code})`,
                  article_id: item.return_shipment.article_id,
                  article_description: item.return_shipment.article_description,
                  city: item.pickup_details.city,
                  pickup_date_new: item.actual_pickup_time ? item.actual_pickup_time : item.actual_pickup_date,
                  drop_date_new: item.receipt_time ? item.receipt_time : item.receipt_date,
                  service_inspection_date: item.service_inspection_date || null,
                  // service_inspection_date: item.customer_declaration_result?.grader_details?.grading_date || null,
                  // service_inspection_done_by: item.customer_declaration_result?.grader_details?.graded_by_name || null,
                  service_inspection_done_by: item.service_inspection_done_by || null,
                  package_validation_date: item.grading_result?.grader_details?.grading_date || null,
                  package_validation_done_by: item.grading_result?.grader_details?.graded_by_name || null,
                }))
                this.totalPages = response.data.meta.total_pages
                this.totalCount = response.data.meta.total_count
                this.filteWithSubPopup = false;
                // this.logistics_partner = null;
                if(!this.is_filter){
                  this.resetFilters();
                }                
                this.loading = false;
              } else {
                this.loading = false;
              }
            })
            .catch(error => {
              this.$toast.error(error.response.data.message)
              this.loading = false;
            });
        },
        fetchTrackTripData() {
          const params = {
            page: this.page,
            per_page: this.pageSize,
            request_type: this.type_of_request || null,
            logistic_partner: this.logistics_partner || null,
            status: this.status || null,
            created_date: this.bid_start_date 
              ? String(this.bid_start_date).split('-').reverse().join('-') 
              : null,
          };
          if(this.search_tag){
            params[this.select_field] = this.search_tag.trim()
          }

          this.loading = true;
          this.$httpSecured
            .get("/api/v1/warehouse/return_initiation/logistic_request_trips", { params })
            .then(response => {
              if (response.data) {
                this.table_data = response.data.logistic_request_trips.map( item => ({
                  ...item,
                  ageing_numeric: parseInt(item.ageing.split(' ')[0]),
                  trip_distance: item.start_odometer_reading && item.end_odometer_reading 
                                ? parseInt(item.end_odometer_reading) - parseInt(item.start_odometer_reading) 
                                : null
                 
                }))
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count;
                this.filteWithSubPopup = false;
                if(!this.is_filter){
                 this.resetFilters();
                }                
                // this.logistics_partner = null;
                this.loading = false;
              } else {
                this.loading = false;
              }
            })
            .catch(error => {
              this.$toast.error(error.response?.data?.message || 'Error fetching data');
              this.loading = false;
            });
        },

        resetFilters() {
          this.status = null;
          this.bid_start_date = null;
          this.type_of_request = null;
          this.logistics_partner = null;
          this.dealer = null;
        },

        fetchCreateTripsDetail(){
          const params = {
            page: this.page,
            per_page: this.pageSize,
            request_type: this.type_of_request || null,
            logistic_partner: this.logistics_partner || null,
            status: this.status || null,
            created_date: this.bid_start_date 
              ? String(this.bid_start_date).split('-').reverse().join('-') 
              : null,
            
          };
          if(this.search_tag){
            params[this.select_field] = this.search_tag
          }
          this.loading = true;
          this.$httpSecured
          .post("/api/v1/warehouse/return_initiation/logistic_request_activities", params )
          .then(response => {
            if (response.data) {
              this.table_data = response.data.logistic_request_activities
              this.totalPages = response.data.meta.total_pages
              this.totalCount = response.data.meta.total_count
              this.filteWithSubPopup = false;
              if(!this.is_filter){
                  this.resetFilters();
                } 
              // this.logistics_partner = null;
              this.loading = false;
            } else {
              this.loading = false;
            }
          })
          .catch(error => {
            this.$toast.error(error.response.data.message)
            this.loading = false;
          });
        },
    submitCreateTrip() {
    this.number++;

    const aggregation_activities = {};
    const activity_sequence = [];
    const sequenceMap = {}; // Tracks assigned sequences for each aggregation_id
    let sequenceCounter = 1; // Global counter for unique sequences

    // First, ensure ALL selected rows are processed (including duplicates)
    this.createtrips_selected.forEach(item => { 
        if (!item.aggregation_id) return; // Ensure aggregation_id exists

        // Store aggregation ID mapping for each activity ID
        aggregation_activities[item.id] = item.aggregation_id;

        // If this aggregation_id already has a sequence assigned, use the same one
        if (!(item.aggregation_id in sequenceMap)) {
            sequenceMap[item.aggregation_id] = item.sequence; // Assign new sequence
        }
        const sequenceValue = sequenceMap[item.aggregation_id]; // Get assigned sequence
        if(!activity_sequence.some(detail => detail.id === item.id))
          activity_sequence.push({
              id: item.id,
              sequence: sequenceValue.toString() // Ensure consistent formatting
          });
        this.crm_ticket_dupl_details[item.aggregation_id].forEach(dupl_item => {
          if(activity_sequence.some(detail => detail.id === dupl_item.id)) return;
          activity_sequence.push({
              id: dupl_item.id,
              sequence: sequenceValue.toString()
          });
          aggregation_activities[dupl_item.id] = item.aggregation_id
        })
    });

    // Ensure payload includes all merged aggregation items
    const payload = {
        aggregation_activities,
        activity_sequence
    };

    console.log("Final Payload:", JSON.stringify(payload, null, 2));

    // Send API request
    this.$httpSecured
        .post("/api/v1/warehouse/return_initiation/logistic_request_activities/create_trip", payload)
        .then(response => {
            this.$toast.success(response.data.message);
            this.createTripPopup = false;
            this.createtrips_selected = [];
            this.loadData(this.active_tab);
        })
        .catch(error => {
            this.number = 0;
            this.snackbar = {
                color: "error",
                icon: "mdi-check-circle",
                mode: "multi-line",
                position: "top",
                timeout: 3000,
                title: "Error",
                text: error.response.data.error,
                visible: true
            };
        });
},

      filterListOfButtons() {
          this.filteWithSubPopup = true;
          this.filter_width = "950px"
          if(window.innerWidth > 1400 && window.innerWidth < 1500)
              this.filter_width = "1050px"
          else if(window.innerWidth >= 1500 && window.innerWidth < 1600)
              this.filter_width = "1150px"
          else if(window.innerWidth >= 1600)
              this.filter_width = "1250px"
          document.documentElement.style.setProperty('--dialog-ypos', (this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 40).toString() + 'px');
        },
        TicketPopup(item){
          this.$store.commit("setLotIds", {
            lotIds: item,
            action: this.active_tab,
            inventoryId: "FTA"
          });
          this.$store.commit("setTrackID", { track_id: "", status: "" });
          this.$router.push({ name: "SubRequestDetails" });
        },
        TicketPopupLR(item){
          this.$store.commit("setLotIds", {
            lotIds: item,
            action: this.active_tab,
            inventoryId: "FTA"
          });
          this.$store.commit("setTrackID", {
            track_id: "lr_trip_id",
            status: ""
          });
          this.$router.push({ name: "SubRequestDetails" });
        },
         handlePageChange(value) {
          this.page = value;
          if(this.addMorePopup===true){
              this.addMoreItems();
          } else if (this.active_tab === "Logistics Requests") {
            this.fetchUpdateLogisticsDetail();
          } else if (this.active_tab === "Create Trips") {
            this.fetchCreateTripsDetail();
          } else {
            this.fetchTrackTripData();
            }
        },
        handlePageSizeChange(size) {
          this.pageSize = size;
          this.page = 1
          if(this.addMorePopup===true){
              this.addMoreItems();
          } else if (this.active_tab === "Logistics Requests") {
            this.fetchUpdateLogisticsDetail();
          } else if (this.active_tab === "Create Trips") {
            this.fetchCreateTripsDetail();
          } else {
            this.fetchTrackTripData();
            }
        },
        fetchreferenceFields(item){
          this.itemInformation = item
          const api = this.active_tab == 'Logistics Requests' ? `/api/v1/warehouse/return_initiation/logistic_request/show_item?id=${item.id}` : 
                      `/api/v1/warehouse/return_initiation/logistic_request_activities/show_item?id=${item.id}`
        this.$httpSecured
            .get(api)
            .then(response => {
              if (response.data) {
                this.referenceDocData = this.active_tab == 'Logistics Requests' ? response.data.return_items[0] : response.data.logistic_request_activity
                // this.itemsTableData = response.data.data.items
                this.referenceDocPopup = true;
              }
            })
            .catch(error => {
              this.$toast.error(error.response.data.message)
              this.loading = false;
            });
        },
        changeAssignmentFunc() {
          if(this.active_tab == 'Track Trips'){
          const logist_partner = this.complete_executive_list.filter(item => { return item.full_name == this.selected[0].logistic_partner})
          this.$httpSecured
          .get(`/api/v1/warehouse/return_initiation/logistic_request/get_associated_field_logistics_executive?id=${logist_partner[0]?.id}`)
          .then(response => {
              this.executive_items = response.data.logistic_executive
            }
          )
          .catch(error => {
            this.$toast.error(error.response.data.error)
          });
        }
          this.number = 0
          this.changeAssignmentPopup = true;
          this.logistics_partner = null
          this.assistant_executive = null
          this.executive = null
          // this.vehicle_number = null
          this.vehicle_number = ''
        },
        changeAssignmentEditFunc() {  
            this.changeAssignmentEditPopup = true
         },
  
        changeAssignConfirm() {
         },
  
         updateStatusFunc(){
          this.number = 0
          this.updateStatusPopup = true;
          this.update_status = null
          this.status_file = null
          if(this.active_tab === 'Track Trips'){
            this.update_status_items = [{ name: 'To Be Assigned' }, { name: 'Assigned'},{ name : 'In Progress'}, { name :'Completed'}]
           if(this.selected[0].status == 'In Progress' || this.selected[0].status == 'Pending Completion')
            this.update_status_items[0].disabled = this.update_status_items[1].disabled = this.update_status_items[2].disabled = true
           else if(this.selected[0].status == 'Assigned')
            this.update_status_items[0].disabled = this.update_status_items[1].disabled = true
           else if(this.selected[0].status == 'To Be Assigned')
            this.update_status_items[0].disabled = true          
          }else{
            this.update_status_items = [{ name: 'Completed'},{ name : 'Cancelled'}]
          }
         },
         updateStatusEditFunc() {  
            this.changeAssignmentEditPopup = true
         },
  
        updateStatusConfirm() {
         },
  
       createTripFunc() {
          // Deep copy selected data to createtrips_selected
          this.createtrips_selected = this.selected.map(item => ({ ...item })); 

          const aggregationMap = {}; 

          this.createtrips_selected.forEach(item => {
            item.sequence = ''; 
            const key = `${item.client_name}_${item.location}_${item.activity_type}`;

            // Generate a completely new aggregation_id for every new trip
            const newAggregationId = `AG-${Math.floor(10000 + Math.random() * 90000)}`;

            if (aggregationMap[key]) {
              item.aggregation_id = aggregationMap[key];
            } else {
              aggregationMap[key] = newAggregationId; 
              item.aggregation_id = newAggregationId;
            }
          });

          //  Sort activities based on priority order
          this.createtrips_selected = this.sortActivities(this.createtrips_selected);
          this.createTripPopup = true;
          
          const activities = [...this.createtrips_selected];
          this.createtrips_selected = [];

          activities.forEach((item, index) => {            
            if (index === 0 || item.aggregation_id !== activities[index - 1].aggregation_id) {
              item.is_expanded = false;
              this.createtrips_selected.push(item);
              this.crm_ticket_dupl_details[item.aggregation_id] = [];
            } else {
              item.is_crm_duplicate = true;
              this.crm_ticket_dupl_details[item.aggregation_id].push(item);
            }
          });

          console.log(this.createtrips_selected);
          this.number = 0;
      },

      sortActivities(data) {
          const priorityOrder = {
            "Replacement Pickup": 1,
            "Return Pickup": 2,
            "Pickup Return": 2,
            "Replacement Drop": 3,
            "Return Drop": 4,
            "Drop": 4
          };

          return data.sort((a, b) => {
            const priorityDiff = priorityOrder[a.activity_type] - priorityOrder[b.activity_type];
            if (priorityDiff !== 0) return priorityDiff;
            const numA = parseInt(a.aggregation_id.replace(/\D/g, ""), 10); 
            const numB = parseInt(b.aggregation_id.replace(/\D/g, ""), 10); 
            return numA - numB;
          });
      },
      deleteTripFunc(){
          this.deleteTripPopup =true
          this.number = 0
        },
        FailedStatusClicked(item){
          this.$store.commit("setLotIds", {
            lotIds: item,
            action: this.active_tab,
            inventoryId: "Failed Status"
          });
          this.$router.push({ name: "SubRequestDetails" });
        },
        TrackTripDetailsPage(item){
          this.$store.commit("setLotIds", {
            lotIds: item.trip_id,
            action: this.active_tab,
            inventoryId: "FTA11"
          });
          this.$router.push({ name: "trackTrips" });
        },
        formatLogisticPartner(partnerString) {
          if (partnerString && typeof partnerString === 'string') {
            const match = partnerString.match(/^\["(.*?)"\]\s*(.*)$/);
            if (match && match[1]) {
              return `${match[1]} ${match[2] || ''}`.trim();
            }
          }
          return partnerString || '-';
        },
        formatDispatchDate(dateString) {
            if (!dateString) return '-';
            const [datePart, timePart] = dateString.split(' ');
            const [year, month, day] = datePart.split('/');
            const formattedDate = `${day}/${month}/${year}`;
            var hour = Number(timePart.split(':')[0])
            let min = Number(timePart.split(':')[1].slice(0,2))
            const ampm = hour >= 12 ? "PM" : "AM";
            hour = hour % 12 || 12;
            hour = String(hour).padStart(2, '0');
            min = String(min).padStart(2, '0');
            return `${formattedDate} ${hour}:${min}${ampm}`;
          },
  
        
        closeFilter(){
          this.filteWithSubPopup = false;
          // this.status = null;
          // this.bid_start_date = null
          // this.type_of_request = null;
          // this.logistics_partner = null;
        },
       updateTripDistance(item){
        item.isLoading = true;
        this.$httpSecured
        .post("/api/v1/warehouse/return_initiation/logistic_request_trips/update_trip_distance_and_cost",
          {
            "id":item.id,
            "trip_distance":item.trip_distance
          }
         )
        .then(response => {
            this.snackbar = true;
               this.email_id='';
              this.snackbar = {
                    color: "success",
                    icon: "mdi-check-circle",
                    mode: "multi-line",
                    position: "bottom",
                    timeout: 3000,
                    title: 'Success',
                    text: response.data.message,
                    visible: true
                  };
            item.isLoading = false;     
            this.loadData(this.active_tab)
          }
        )
        .catch(error => {
          item.isLoading = false;
          this.$toast.error(error.response.data.message)
        });
       },
        updateTripLogiCost(item){
        item.isLoadingCost = true;
        this.$httpSecured
        .post("/api/v1/warehouse/return_initiation/logistic_request_trips/update_trip_distance_and_cost",
          {
            "id":item.id,
            "logistic_cost":item.logistic_cost,
            "trip_distance":item.trip_distance
          }
         )
        .then(response => {
            this.snackbar = true;
               this.email_id='';
              this.snackbar = {
                    color: "success",
                    icon: "mdi-check-circle",
                    mode: "multi-line",
                    position: "bottom",
                    timeout: 3000,
                    title: 'Success',
                    text: response.data.message,
                    visible: true
                  };
            item.isLoadingCost = false;     
            this.loadData(this.active_tab)
          }
        )
        .catch(error => {
          item.isLoadingCost = false;
          this.$toast.error(error.response.data.message)
        });
       },
     formatExpectedLiquidation(item) {
        const numericValue = parseFloat(item.formatted_expected_liquidation.replace(/[^0-9.]+/g, ''));
        if (!isNaN(numericValue)) {
          item.formatted_expected_liquidation = this.formatCurrency(numericValue);
          item.logistic_cost = numericValue;
        } else {
          item.formatted_expected_liquidation = '';
          item.logistic_cost = null;
        }
      },
      updateFailedAction(action,item){
        const ids = [item.id]
        this.$httpSecured
        .post("/api/v1/warehouse/return_initiation/logistic_request/delete_reschedule_request", { "return_item_ids": ids,
               "item_action" : action == 'Reschedule' ? 'reschedule' : 'delete'
        } )
        .then(response => {
            this.$toast.success(response.data.message)
            this.loadData(this.active_tab)
          }
        )
        .catch(error => {
          this.$toast.error(error.response.data.error)
        });
      },
      formatCurrency(value) {
        return Number(value).toLocaleString('en-IN') === "0" ? null : Number(value).toLocaleString('en-IN')
      },
      updateLogisticsExecutive(){
        this.$httpSecured
        .get(`/api/v1/warehouse/return_initiation/logistic_request/get_associated_field_logistics_executive?id=${this.logistics_partner}`)
        .then(response => {
            this.executive_items = response.data.logistic_executive
          }
        )
        .catch(error => {
          this.$toast.error(error.response.data.error)
        });
      },
      returnRequestDetailPopup(item,action){
          this.$store.commit("setRequestDetails",{
            actionRequest : this.headerText,
            items : JSON.stringify(item),
          });
            this.$router.push({ name: 'ReturnRequestIdDetailsRia' });
        },
        format_table_data(value){
          this.edit_table_data = []
          this.crm_ticket_edit_dupl_details = {}
          value.forEach((item, index) => {        
            if (index === 0 || item.aggregation_id !== this.edit_table_data[this.edit_table_data.length - 1].aggregation_id) {
              item.is_expanded = false;
              item.is_crm_duplicate = false;
              this.edit_table_data.push(item);
              this.crm_ticket_edit_dupl_details[item.aggregation_id] = [];
            } else {
              item.is_crm_duplicate = true;
              item.is_expanded = false;
              this.crm_ticket_edit_dupl_details[item.aggregation_id].push(item);
            }
          });
        },
        editDialog(val) {
          const params = {}
            if(val === 'search'){
              const searched_value = this.complete_edit_data.filter(item => item[this.field_type].includes(this.edit_search))
              this.format_table_data(searched_value)             
            }else{
              this.editPopup = true;
              this.selected_add = [];
              this.delete_activity_data = [];
              this.complete_edit_data = []
              this.edit_search = '';
              this.field_type = null;
              this.assistant_executive = null;
              this.executive = null;
              this.number = 0
              this.selected_edit = [];
              this.$httpSecured
              .get(`/api/v1/warehouse/return_initiation/logistic_request_trips/show_item?id=${this.selected[0].id}`, { params })
              .then(response => {
                this.logistic_partner_id = response.data.trip.logistic_partner_id;
                this.trip_id = response.data.trip.id;
                this.complete_edit_data = response.data.activities.map((item) => item); 
                this.format_table_data(this.complete_edit_data)
              })
              .catch(error => {
                this.$toast.error(error.response.data.error)
              });
            }
          },
        
         addMoreItems(val){
          const params = {
            page: this.page,
            per_page: this.pageSize,
          }
            if(val === 'search'){
              params['crm_ticket_no'] = this.change_search
            }else{
              this.addMorePopup = true;
              this.change_search = '';
            }
          this.$httpSecured
            .get(`/api/v1/warehouse/return_initiation/logistic_request_activities?activity_status=To Be Assigned&logistic_partner_id=${this.logistic_partner_id}`,  { params })
            .then(response => {
                this.addmore_table_data = response.data.logistic_request_activities;
                this.totalPages = response.data.meta.total_pages
                this.totalCount = response.data.meta.total_count
              }
            )
            .catch(error => {
              this.$toast.error(error.response.data.error)
            });  
         },
         canEditTrip() {
              if (this.selected.length === 0) return false;
              const groupedByCrm = this.groupBy(this.selected, "crm_ticket_number");
              return this.selected.every((item) => {
                if (item.request_type === "Return") {
                  return (
                    groupedByCrm[item.crm_ticket_number].length === 2 &&
                    this.hasUniqueActivities(groupedByCrm[item.crm_ticket_number])
                  );
                } else if (item.request_type === "Replacement") {
                  return (
                    groupedByCrm[item.crm_ticket_number].length === 4 &&
                    this.hasUniqueActivities(groupedByCrm[item.crm_ticket_number])
                  );
                }
                return false;
              });
            },
         addEdit(value){
          const aggregation_key = {};  
          this.edit_table_data.forEach((item) => {
            const activity_type = item.activity_type == 'Pickup Return' ? 'Return Pickup' : item.activity_type == 'Drop' ? 'Return Drop' : item.activity_type
            aggregation_key[`${item.client_name}_${item.activity_location}_${activity_type}`] = item.aggregation_id
          })
          if (this.selected_add && this.selected_add.length > 0) {
            const updatedData = this.selected_add.map((item) => {
              if (item.ticket_number) {
                  return {
                    ...item,
                    sub_request_id: item.ticket_number,
                    activity_id: item.id,
                    trip_sequence: ''
                  };
                }
                return item;
              })
              updatedData.forEach((item) => {
                const activity_type = item.activity_type == 'Pickup Return' ? 'Return Pickup' : item.activity_type == 'Drop' ? 'Return Drop' : item.activity_type
                if(this.edit_table_data.some((editItem) => editItem.activity_id === item.activity_id)) return
                if (aggregation_key[`${item.client_name}_${item.activity_location}_${activity_type}`]) {
                  item.aggregation_id = aggregation_key[`${item.client_name}_${item.activity_location}_${activity_type}`]
                } else {
                  item.aggregation_id = aggregation_key[`${item.client_name}_${item.activity_location}_${activity_type}`] = `AG-${Math.floor(10000 + Math.random() * 90000)}`
                }
                this.complete_edit_data.push(item)
              })
              this.complete_edit_data = this.sortActivities(this.complete_edit_data)
              this.format_table_data(this.complete_edit_data)
          }
            if(value !== 'search'){
              this.addMorePopup=false;
              this.editPopup = true;
            }       
         },
         changeAssignmentEdit(){
         },
        deleteEditTracker() {
          this.complete_edit_data = this.complete_edit_data.filter(item => !this.selected_edit.some(selectedItem => selectedItem.activity_id == item.activity_id));
          this.format_table_data(this.complete_edit_data)
          this.selected_edit = []
        },
         saveAndUpdate(){
          this.number++;     
          const aggregation_activities = {};
          const activity_sequence = [];   
          this.edit_table_data.forEach((item) => {
            aggregation_activities[item.activity_id] = item.aggregation_id;
            if(!activity_sequence.some(detail => detail.id === item.id))
              activity_sequence.push({
                  id: item.activity_id,
                  sequence: item.trip_sequence.toString()
              });
            this.crm_ticket_edit_dupl_details[item.aggregation_id].forEach(dupl_item => {
              if(activity_sequence.some(detail => detail.id === dupl_item.id)) return;
              activity_sequence.push({
                  id: dupl_item.activity_id,
                  sequence: item.trip_sequence.toString()
              });
              aggregation_activities[dupl_item.activity_id] = item.aggregation_id
            })
          })
          this.$httpSecured
          .post("/api/v1/warehouse/return_initiation/logistic_request_trips/update_trip_activities", { 'trip_id':this.trip_id, 'activity_sequence' : activity_sequence,'aggregation_activities' : aggregation_activities} )
          .then(response => {
              this.editPopup=false;
              if(this.assistant_executive && this.executive){
                this.submitUpdateAssignment();
              }
              this.$toast.success('Trip updated successfully');
              this.loadData(this.active_tab);
              this.number = 0
            }
          )
          .catch(error => {
            this.number = 0
            this.snackbar = true;
            this.snackbar = {
              color: "error",
              icon: "mdi-check-circle",
              mode: "multi-line",
              position: "top",
              timeout: 3000,
              title: 'Success',
              text: error.response.data.error,
              visible: true
            };          
          });
         },
         DropdownAction(value) {
          this.disabled_date_time = false;
            this.selectedValue = value;
            this.clearDataOfUpdate();
            if (value === 'ConfirmationGiven' || value === 'cancel') {
              this.confirmationGivenPopup = true;
              this.getCancellationReason();
            } else if (value === 'update_pickup_details') {
              const box_ids = new Set(this.selected.map(item => item.box_id));
                const boxIdList = [...box_ids].join(', ');
                  if (this.isConfigEnabled('BOX_ID_VALIDATION_FOR_ASSIGNMENT') && this.selected.length !== this.table_data.filter(item => box_ids.has(item.box_id)).length) {
                    this.$toast.error(`Please select all tickets associated with Box ID(s): ${boxIdList} to proceed.`);
                    return;
                  }
              const datetime = this.selected[0].actual_pickup_time ? this.selected[0].actual_pickup_time : this.selected[0].actual_pickup_date
              this.select_doc = this.selected[0].dispatch_document_type;
              this.dispatch_docu_number = this.selected[0].dispatch_document_number;
              if(this.selected[0].dispatch_document_url){
                const parts = this.selected[0].dispatch_document_url.split('/');
               this.document_name = parts[parts.length - 1];
              }              
                if (datetime) {
                   const [datePart, timePart, meridian] = datetime.split(/[\s:]+/);
                   const [day, month, year] = datePart.split('/');

                    const formattedDate = `${year}-${month}-${day}`;
                    this.logistics_partner_date = new Date(formattedDate);

                    // Only set time if available
                    if (timePart && meridian) {
                      const hour = timePart;
                      const minute = datetime.split(' ')[1]?.split(':')[1] || '00';
                      this.executive_time = `${hour}:${minute}`;
                    } else {
                      this.executive_time = ''; // or null, if no time provided
                    }
                }
              this.confirmationGivenPopup = true;
              this.getSelectDocList();
            } else if (value === 'update_drop_details') {              
              this.confirmationGivenPopup = true;
              this.getSelectDocList();
            } else if (value === 'cancel1') {
              this.confirmationGivenPopup = true;
              this.getCancellationReason();
            }       
          }, 
        disableCondition11(item) {
            if (!this.selected.length) return true;
            const status = this.selected[0].logistic_status;
            var uniquw_box = Array.from(new Set(this.selected.map(x => x.box_id)));
            switch (item.value) {
              case "cancel1":
                return !(status === "Assigned" || status === "To Be Confirmed" || status === "To Be Assigned");
              case "update_pickup_details":
                return !(status === "Assigned");
              case "update_drop_details":
                return status !== "In Transit";
              default:
                return false;
            }
          },
         disableCondition12(item) {
        //  if(this.selected[0].logistic_status === 'To Be Confirmed')
        //     return item.value == 'ConfirmationGiven'
          // else if(this.selected[0].logistic_status == 'Assigned' || this.selected[0].logistic_status == 'To Be Assigned')
          //   return item.value == 'ConfirmationGiven'
          return false;
        },
        disbaledUpdateConfirm() {
          if (this.selected.length === 0) return true;
          // if(this.configurations.some(item => item.constant === "CALL_CONTROL_TOWER" && item.is_enabled === true)) return true;
          const validStatuses = ["To Be Confirmed"];
          const selectedStatuses = [...new Set(this.selected.map(item => item.logistic_status))];
          const allValid = selectedStatuses.every(status => validStatuses.includes(status));
          return !(allValid && selectedStatuses.length === 1);
        },
        disbaledUpdateAssign() {
          if (this.selected.length === 0) return true;
          // if(this.configurations.some(item => item.constant === "CALL_CONTROL_TOWER" && item.is_enabled === true)) return true;
          const validStatuses = ["To Be Assigned","Assigned"];
          const selectedStatuses = [...new Set(this.selected.map(item => item.logistic_status))];
          const allValid = selectedStatuses.every(status => validStatuses.includes(status));
          return !(allValid && selectedStatuses.length === 1);
        },
        changeAssignmentFunc2(){
          const box_ids = new Set(this.selected.map(item=> item.box_id))
          const boxIdList = [...box_ids].join(', ');
          if(this.isConfigEnabled('BOX_ID_VALIDATION_FOR_ASSIGNMENT') && (this.selected.length != this.table_data.filter(item => box_ids.has(item.box_id) && ["To Be Assigned","Assigned"].includes(item.logistic_status)).length)){
            this.$toast.error(`Please select all tickets associated with Box ID(s) ${boxIdList} to proceed.`)
            return;
          }
          this.changeAssignmentPopup2 = true;
          this.change_assignment = null;
          this.vehicle_number_aasign = null;
          this.driver_mobile_number = null;
        },
        getCancellationReason(){
        this.$httpSecured
          .get("/api/v1/warehouse/return_initiation/logistic_request/cancel_reasons")
          .then(response => {
              this.cancellation_Reason_items = response.data.reasons
              this.assistant_executive_items = response.data.remarks
            }
          )
          .catch(error => {
            this.$toast.error(error.response.data.message)
          });
        },
        getSelectDocList(){
        this.$httpSecured
          .get("/api/v1/warehouse/return_initiation/logistic_request/pickup_details_documents")
          .then(response => {              
              if(this.selectedValue == 'update_pickup_details'){
                this.select_doc_items = response.data.documents;
                this.buffer_days = response.data.buffer_days
              }else{
                this.select_doc_items = response.data.drop_documents;
                this.buffer_days = 0
              }
              
            }
          )
          .catch(error => {
            this.$toast.error(error.response.data.message)
          });
        },
        submitUpdateConfirmation(){
          this.number++;
          let params = {};
          let end_point = '';
          const convertTimeToUTC = (time) => {
            if (!time) return null;

            // Get current date in YYYY-MM-DD format to create a valid Date object
            const today = new Date().toISOString().split('T')[0]; 

            // Create a Date object using today's date and the provided time
            const localDateTime = new Date(`${today}T${time}:00`);

            if (isNaN(localDateTime.getTime())) {
              console.error("Invalid time:", time);
              return null;
            }

            // Extract only the UTC time (HH:mm)
            const utcTime = localDateTime.toISOString().split('T')[1].substring(0, 5);
            return utcTime;
          };

          if(this.selectedValue == 'ConfirmationGiven'){
            end_point = '/api/v1/warehouse/return_initiation/logistic_request/update_confirmation';
            params = {
              "ids": this.selected.map(item=> item.id),
              "suggested_pickup_date": this.dateMenu_Confirmation,
              "suggested_pickup_time": convertTimeToUTC(this.executive_time),
              "remarks": this.assistant_executive,
            }
          }else if(this.selectedValue == 'cancel' || this.selectedValue == 'cancel1'){
             end_point = '/api/v1/warehouse/return_initiation/logistic_request/cancel_request';
            params = {
              "ids": this.selected.map(item=> item.id),
              "cancellation_reason": this.cancellation_Reason,
              "remarks": this.other_remarks,
            }
          }else if(this.selectedValue == 'update_pickup_details'){
            end_point = '/api/v1/warehouse/return_initiation/logistic_request/update_pickup_details';
              const formData = new FormData();
                this.selected.forEach(item => {
                  formData.append("ids[]", item.id);
                });
                formData.append("actual_pickup_date", this.dateMenu_Confirmation);
                if(this.executive_time){
                 formData.append("actual_pickup_time", this.executive_time);
                }
                if(this.dispatch_docu_number){
                  formData.append("dispatch_document_number", this.dispatch_docu_number);
                }
                if(this.select_doc){
                  formData.append("dispatch_document_type", this.select_doc);
                }
                if (this.doc_file) {
                  formData.append("dispatch_document", this.doc_file);  // ✅ Append the file
                }
                params = formData;
          }else if(this.selectedValue == 'update_drop_details'){
            end_point = '/api/v1/warehouse/return_initiation/logistic_request/update_drop_details';
            const formData = new FormData();
                this.selected.forEach(item => {
                  formData.append("ids[]", item.id);
                });
                formData.append("receipt_date", this.dateMenu_Confirmation);
                if(this.executive_time){
                 formData.append("receipt_time", this.executive_time);
                }
                if(this.dispatch_docu_number){
                  formData.append("drop_document_number", this.dispatch_docu_number);
                }
                if(this.select_doc){
                  formData.append("drop_document_type", this.select_doc);
                }
                if (this.doc_file) {
                  formData.append("dispatch_document", this.doc_file);  // ✅ Append the file
                }
                params = formData;
          }
         this.$httpSecured.put(end_point, params)
          .then(response => {
            if (response.data) {
              this.confirmationGivenPopup = false;
              this.select_doc = null;
              this.dispatch_docu_number = null;
              this.doc_file = null;
              this.clearDataOfUpdate();
              this.loadData(this.active_tab);
              this.snackbar = {
              color: "success",
              icon: "mdi-check-circle",
              mode: "multi-line",
              position: "bottom",
              timeout: 2000,
              title: 'Success',
              text: response.data.message,
              visible: true
            }; 
            } else {
              this.number = 0;
              this.$toast.error("No Data Found");
            }
          }).catch(error => {
            this.$toast.error(error.response.data.error)
            this.number = 0;
            this.loading = false;

          });               
          
        },
        disbaledUpdateStatus() {
          if (this.selected.length === 0) return true;
          // if(this.configurations.some(item => item.constant === "CALL_CONTROL_TOWER" && item.is_enabled === true)) return true;
          const validStatuses = ["To Be Confirmed","To Be Assigned", "Assigned","In Transit"];
          const selectedStatuses = [...new Set(this.selected.map(item => item.logistic_status))];
          const allValid = selectedStatuses.every(status => validStatuses.includes(status));
        //  if (this.fta_logistics_has_taken === true && selectedStatuses.includes("In Transit")) {
        //     return true;
        //   }
          return !(allValid && selectedStatuses.length === 1);
        },
        updateLabelName(){
          if(this.selectedValue == 'ConfirmationGiven'){
            return 'Suggested Pick Up Date';
          }else if(this.selectedValue == 'update_pickup_details'){
            return 'Pick Up Date';
          }else if(this.selectedValue == 'update_drop_details'){
            return 'Drop Date';
          }
        },
        updateTimelabelName(){
          if(this.selectedValue == 'ConfirmationGiven'){
            return 'Suggested Pick Up Time';
          }else if(this.selectedValue == 'update_pickup_details'){
            return 'Pick Up Time (Optional)';
          }else if(this.selectedValue == 'update_drop_details'){
            return 'Drop Time (Optional)';
          }
        },
      clearDataOfUpdate(){
        this.logistics_partner_date = null;
        this.dateMenu = false;
        this.executive_time = null;
        this.dispatch_docu_number = null;
        this.assistant_executive = null;
        this.cancellation_Reason = null;
        this.other_remarks = null;
        this.doc_file = null;
    },
    odometerOpenDialog(image, string){
      this.odometer_label = string;
      this.odometer_image = image;
      this.odometerImagePopup = true
    },
    changeRemarks(){
      if(this.assistant_executive === 'RNR (Ring No Response)' || this.assistant_executive === 'Dealers details needed'){
         this.logistics_partner_date = null;
         this.executive_time = null;
         this.disabled_date_time = true
      }else{
        this.disabled_date_time = false
      }
    } ,
    actionEnaledBasedOnControlTower(){
      if(this.configurations.some(item => item.constant === "CALL_CONTROL_TOWER" && item.is_enabled === true)){
          return true
      }
    },
      isRowDisabled(item) {
        return item.is_sync_to_control_tower;
      },
      toggleSelect(item, shouldSelect) {
        const index = this.selected.findIndex(i => i.id === item.id)
        if (shouldSelect && index === -1) {
          this.selected.push(item)
        } else if (!shouldSelect && index !== -1) {
          this.selected.splice(index, 1)
        }
      },
     downloadFlatData() {
      let headerTexts, headerKeys;
      let dispatchGroupKeys = [
        'dispatch_document_number',
        'dispatch_document_type',
        'dispatch_document_url'
      ];
      if (this.roles.includes('admin')) {
        const sampleData = this.table_data[0];
        headerKeys = Object.keys(sampleData);
        const group = headerKeys.filter(key => dispatchGroupKeys.includes(key));
        const others = headerKeys.filter(key => !dispatchGroupKeys.includes(key));
        headerKeys = [...others, ...group];
        headerTexts = headerKeys;
      } else {
        headerTexts = this.headers.map(h => h.title);
        headerKeys = this.headers.map(h => h.key);
      }

      const filteredKeys = headerKeys.filter(key => {
        const val = (this.table_data[0] || {})[key];
        return !(Array.isArray(val) || (val !== null && typeof val === "object"));
      });
      const filteredTexts = headerTexts.filter((_, i) => filteredKeys.includes(headerKeys[i]));

      const flatData = (this.selected.length > 0 ? this.selected : this.table_data).map(row => {
        const flatRow = {};
        filteredKeys.forEach(key => {
          let val = row[key];
          if (Array.isArray(val) || (val !== null && typeof val === "object")) {
            val = ""; 
          }
          flatRow[key] = val !== undefined ? val : "";
        });
        return flatRow;
      });

      const csvRows = [];

      csvRows.push(filteredTexts.join(","));
      flatData.forEach(row => {
        const values = filteredKeys.map(key => `"${row[key] ?? ""}"`);
        csvRows.push(values.join(","));
      });

      const csv = csvRows.join("\n");
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", "logistics_requests.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    changeFile() {
      if (this.doc_file) {
        const fileType = this.doc_file.type;
        this.document_name = "";
        if (fileType !== 'application/pdf' && fileType !== 'image/png') {
          this.fileError = true;
          this.fileErrorMessage = 'Only PDF and PNG files are allowed.';
        } else {
          this.fileError = false;
          this.fileErrorMessage = '';
        }

      }
    },
      convertToCSV(objArray) {
        const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
        const headers = Object.keys(array[0]);
        const formatHeader = (key) => {
          return key
            .replace(/_/g, ' ') 
            .replace(/([a-z])([A-Z])/g, '$1 $2') 
            .replace(/\b\w/g, c => c.toUpperCase()); 
        };

        const headerRow = headers.map(formatHeader).join(',');

        const csvRows = [headerRow];

        array.forEach(row => {
          const values = headers.map(header => `"${(row[header] ?? '').toString().replace(/"/g, '""')}"`);
          csvRows.push(values.join(','));
        });

        return csvRows.join('\r\n');
      }
    }
   }
    
  </script>
  <style scoped>
    .v-dialog:has(.filter-dispatch) {
      justify-content: right;
      align-items: baseline;
      top: var(--dialog-ypos);
      overflow: hidden !important;
    }
  
    .v-dialog>.v-card>:has(.v-card__title) {
      overflow-wrap: break-word !important;
    }
  
    .custom-control_outlined .v-expansion-panel:before {
      box-shadow: none;
    }
  
    .custom-control_outlined button {
      min-height: 52px;
      border-width: 1px;
      border-color: rgba(0, 0, 0, .42);
      border-style: solid;
    }
  
    .custom-control_outlined button:focus {
      outline: none;
    }
    .item-selected {
    margin-top: 23px;
    position: absolute;
    left: 41%;
  }
  /* .warningText{
      font-size: 20px;
      font-weight: 400;
      color: #0C0C0C;
    } */
  
  @media (max-height: 1104px) {
    .PaddingItemPerPage {
      padding: 8px !important;
    }
  }
  
  @media (min-height: 1126px) {
    .PaddingItemPerPage {
      padding: 24px !important;
    }
  }
  .v-data-table {
    height: calc(var(--vh, 1vh) * 100 - 310px) !important;
  }
  .add_table .v-data-table {
    height: calc(var(--vh, 1vh) * 100 - 230px) !important;
  }
  .edit_table .v-data-table {
    height: calc(var(--vh, 1vh) * 100 - 170px) !important;
  }

  .successfulpopup{
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
  }
  .value_css{
    font-weight: 600;
    font-size: 14px;
    line-height: 16.94px;
  }
  .disabled-icon {
  cursor: not-allowed;
  color: grey;

  }
  .filter_ui{
    margin-left: 18px !important;
    margin-top: 12px !important;
  }
  .image-fit {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain; /* Ensures the whole image fits */
    padding:10px;
    border-radius:15px;
  }
  :deep(.custom-width-table .v-table.v-table--fixed-header > .v-table__wrapper > table > thead > tr > th) {
  min-width: 180px !important;
  white-space: nowrap !important;
}
.custom-width-table .v-data-table {
    height: calc(var(--vh, 1vh) * 100 - 170px) !important;
}
.sort-icon {
  opacity: 1;
  transition: opacity 0.2s ease;
}

.hover-icon {
  opacity: 0;
}

.sortable-header:hover .hover-icon {
  opacity: 0.4;
}
</style>